import * as React from 'react'

import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import * as XLSX from 'xlsx'

// import htmlDocx from 'html-docx-js/dist/html-docx'

import { saveAs } from 'file-saver'

import File from 'mdi-material-ui/File'
import FilePdfBox from 'mdi-material-ui/FilePdfBox'
import MenuDown from 'mdi-material-ui/MenuDown'
import {
  Card,
  CardContent,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'
import {
  ReportsVariants,
  getVariantReportsById,
  Reports,
  getReports,
  getReportsByID,
  Sample,
  Patients,
  fetchPatientBySampleId,
  getVariantReports,
  VariantDetail,
  fetchVariantDetails,
  GetArticlesDto,
  getArticles,
  TranslateDto,
  translate,
  editReports,
  fetchAnalysisVariantDetails,
  fetchAnalyzeInfoByAnalysisId,
  getCnvChromPlot,
  Variation,
  getSamplesSvn,
  getAnalysisVariants,
  TranslateBulkDto,
  translates,
  ISamplesQcData,
  getQCData,
  getBatchLitvarArticles,
  getLitVarArticles,
  IVariantRohData,
  fetchRohList,
  IVariantRohList,
  UserACMGLogs,
  fetchUserACMGLogs,
  ObjectType,
  VariantDetailOmimData,
  fetchOMIM,
  GetVariantLiteratureDto,
  getVarDetail,
  GetMitoMapDataDto,
  fetchMitomap,
  IMitoMapSearchSource,
  getScipCnvDescription,
  GetCnvScipDescriptionDto,
  getGlsVariants,
  getCitationsByVariation,
  getGlsQc,
  GlsQc,
  getGlsRoh
} from '@/@core/services/app.service'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, {
  AccordionSummaryProps
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Index from '../../Index'
import { Litecoin, ProgressPencil } from 'mdi-material-ui'
import { useRouter } from 'next/router'
import {
  changeV1Filter,
  chromosomeRegion,
  deserialize,
  extractFirstNumber,
  filterObjectsByTextWithRemainder,
  formatDate,
  formatVariantInheritance,
  isJson,
  parseGenomicString,
  PrintHtmlToPDF,
  PrintReactHtmlToPDF,
  unique
} from '@/@core/utils/utils'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { EditorWrapper } from '@/@core/components/draft/react-draft-wysiwyg-style'
import EditorControlled from '@/@core/components/draft/EditorControlled'
import PasteHtmlExample from '@/@core/components/braft/react-slate'
import PositionedSnackbar from '@/@core/components/message'
import { useReactToPrint } from 'react-to-print'
import { NObject } from '@/@core/components/filter-variants'
import { handleSetVlaue, handleSetVlaue2 } from './new-report/FormReport'
import { getACMG } from '../../ACMG/ACMGClassification'
import _ from 'lodash'
import ChatClaudeItem from '@/layouts/components/vertical/ChatClaudeItem'
import { strRang } from '../../VariationTables'
import { chromSizes } from '@/pages/samples/SampleTabs/[id]'
import i18n from '@/configs/i18n'
import { judgeStrength } from '../../ACMG'
import { getTemplate1 } from './report-template/template1'
import { getTemplate2 } from './report-template/template2'
import { getTemplate3 } from './report-template/template3'
import { getTemplate4 } from './report-template/template4'
import { getTemplate12 } from './report-template/template12'
import { getTemplate5 } from './report-template/template5'
import { template6And7 } from './report-template/template6&7'
import { getTemplate8 } from './report-template/template8'
import { getTemplate9 } from './report-template/template9'
import { getTemplate10 } from './report-template/template10'
import { getTemplate11And13 } from './report-template/template11&13'
import WordReport from './new-report/WordReport'
import ElectronicSignature from './SignatureCanvas'
import { useDropzone } from 'react-dropzone'
import { getVariantId } from './new-report'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0
  },
  '&:before': {
    display: 'none'
  }
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={null} {...props} />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',

  // flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1)
  }
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)'
}))

export const MT_Site_Detail = [
  {
    gene1: 'G583A',
    omim1:
      '线粒体脑肌病，乳酸性酸中毒和卒中样发作(MELAS)/线粒体肌病和运动不耐受',
    acmg1: 'Pathogenic',
    gene2: 'T578C',
    acmg2: 'Likely pathogenic',
    omim2: '多发性硬化症'
  },
  {
    gene1: 'T616C',
    acmg1: 'Pathogenic',
    omim1: '母系遗传性癫痫/肾病 ',
    gene2: 'G586A',
    acmg2: 'Likely pathogenic',
    omim2: '锥体束外疾病伴运动僵硬,精神疾病和感音神经性听力损失'
  },
  {
    gene1: 'C1494T',
    acmg1: 'Pathogenic',
    omim1: '耳聋',
    gene2: 'C602T',
    acmg2: 'Likely pathogenic',
    omim2: '轴性肌病伴脑病'
  },
  {
    gene1: 'A1555G',
    acmg1: 'Pathogenic',
    omim1: '耳聋/自闭症智力残疾/可能与抗动脉粥样硬化有关',
    gene2: 'T616G',
    acmg2: 'Likely pathogenic',
    omim2: '母系遗传性癫痫'
  },
  {
    gene1: 'G1606A',
    acmg1: 'Pathogenic',
    omim1: '共济失调、肌阵挛和耳聋',
    gene2: 'G617A',
    acmg2: 'Likely pathogenic',
    omim2: '颈动脉狭窄'
  },
  {
    gene1: 'A1630G',
    acmg1: 'Pathogenic',
    omim1:
      '类线粒体神经消化道脑肌病/线粒体脑肌病，乳酸性酸中毒和卒中样发作(MELAS)',
    gene2: 'T618G',
    acmg2: 'Likely pathogenic',
    omim2: '下垂性进行性眼外肌麻痹线粒体肌病和运动不耐受'
  },
  {
    gene1: 'G1644A',
    acmg1: 'Pathogenic',
    omim1: 'Leigh 综合征/HCM+线粒体脑肌病/乳酸性酸中毒和卒中样发作(MELAS)',
    gene2: 'G625A',
    acmg2: 'Likely pathogenic',
    omim2: '感音神经性听力损失和癫痫'
  },
  {
    gene1: 'A3243G',
    acmg1: 'Pathogenic',
    omim1:
      '线粒体脑肌病，乳酸性酸中毒和卒中样发作(MELAS)/Leigh 综合征/糖尿病耳聋/母亲遗传的糖尿病和耳聋（MIDD）/感音神经性听力损失/慢性进行性眼外肌麻痹/线粒体肌病/FSGS/ASD/多发性心脏器官功能障碍',
    gene2: 'C1624T',
    acmg2: 'Likely pathogenic',
    omim2: 'Leigh 综合征'
  },
  {
    gene1: 'A3243T',
    acmg1: 'Pathogenic',
    omim1:
      '线粒体肌病/线粒体脑肌病，乳酸性酸中毒和卒中样发作(MELAS)/感音神经性听力损失/慢性进行性眼外肌麻痹(CPEO)',
    gene2: 'G3255A',
    acmg2: 'Likely pathogenic',
    omim2: '肌阵挛癫痫伴红色破碎肌纤维症/Kearns-Sayre 综合征'
  },
  {
    gene1: 'C3256T',
    acmg1: 'Pathogenic',
    omim1: '线粒体脑肌病，乳酸性酸中毒和卒中样发作(MELAS)；动脉粥样性硬化风险',
    gene2: 'A3274G',
    acmg2: 'Likely pathogenic',
    omim2: '神经精神病综合症+白内障'
  },
  {
    gene1: 'T3258C',
    acmg1: 'Pathogenic',
    omim1: '线粒体脑肌病，乳酸性酸中毒和卒中样发作(MELAS)/肌病',
    gene2: 'A4269G',
    acmg2: 'Likely pathogenic',
    omim2: '致命性小儿心肌病和 MELAS 相关性心肌病'
  },
  {
    gene1: 'A3260G',
    acmg1: 'Pathogenic',
    omim1: '母系遗传性肌病和心肌病',
    gene2: 'T4274C',
    acmg2: 'Likely pathogenic',
    omim2: '进行性眼外肌麻痹/运动神经元疾病'
  },
  {
    gene1: 'T3271C',
    acmg1: 'Pathogenic',
    omim1: '线粒体脑肌病，乳酸性酸中毒和卒中样发作(MELAS)',
    gene2: 'A4281G',
    acmg2: 'Likely pathogenic',
    omim2: '复发性肌红蛋白尿'
  },
  {
    gene1: 'A3280G',
    acmg1: 'Pathogenic',
    omim1: '肌病',
    gene2: 'G4282A',
    acmg2: 'Likely pathogenic',
    omim2: '进行性眼外肌麻痹 plus'
  },
  {
    gene1: 'T3291C',
    acmg1: 'Pathogenic',
    omim1: '线粒体脑肌病，乳酸性酸中毒和卒中样发作(MELAS)/肌病/耳聋和认知障碍',
    gene2: 'T4285C',
    acmg2: 'Likely pathogenic',
    omim2: '进行性眼外肌麻痹'
  },
  {
    gene1: 'A3302G',
    acmg1: 'Pathogenic',
    omim1: '线粒体肌病',
    gene2: 'T4289C',
    acmg2: 'Likely pathogenic',
    omim2: '视网膜病变+糖尿病+吞咽困难+脑萎缩'
  },
  {
    gene1: 'C3303T',
    acmg1: 'Pathogenic',
    omim1: '母系遗传性肌病和心肌病',
    gene2: 'G4403A',
    acmg2: 'Likely pathogenic',
    omim2: '线粒体肌病'
  },
  {
    gene1: 'G3376A',
    acmg1: 'Pathogenic',
    omim1:
      'Leber 遗传性视神经病（LHON)和线粒体脑肌病、乳酸酸中毒和卒中样发作（MELAS）重叠',
    gene2: 'G4412A',
    acmg2: 'Likely pathogenic',
    omim2: '肌病和视网膜病变'
  }
]

export const DEL_evidences = [
  { key: '1A', value: '包含蛋白编码基因或者其它已知重要功能元件' },
  { key: '1B', value: '不包含蛋白编码基因或者其它已知重要功能元件' },
  { key: '2A', value: '完全覆盖已知HI基因/区域' },
  { key: '2B', value: '部分覆盖包含已知的HI基因组区域' },
  { key: '2C', value: '部分覆盖已知HI基因5’UTR' },
  { key: '2C-1', value: '部分覆盖已知HI基因5’UTR，包括编码区域' },
  { key: '2C-2', value: '部分覆盖已知HI基因5’UTR，不包括编码区域' },
  { key: '2D', value: '部分覆盖已知HI基因3’UTR' },
  { key: '2D-1', value: '部分覆盖已知HI基因3’UTR,仅包含3’UTR序列' },
  {
    key: '2D-2',
    value:
      '部分覆盖已知HI基因3’UTR,包括最后一个外显子，且该外显子有已知致病变异'
  },
  {
    key: '2D-3',
    value:
      '部分覆盖已知HI基因3’UTR,包括最后一个外显子，且该外显子没有已知致病变异'
  },
  {
    key: '2D-4',
    value: '部分覆盖已知HI基因3’UTR,包括其它外显子，预期会导致NMD'
  },
  { key: '2E', value: '两端断点都在同一个基因内（基因内CNV）' },
  { key: '2F', value: '完全被已知良性基因/区域覆盖' },
  { key: '2G', value: '包含已知良性基因/区域，但还有其它区域' },
  { key: '2H', value: '两种或更多HI预测算法预测该区域包含至少一个HI基因' },
  { key: '3A', value: '0-24个基因' },
  { key: '3B', value: '25-34个基因' },
  { key: '3C', value: '大于等于35个基因' },
  { key: '4A', value: '已报道的表型高度特异，而且属于该基因或区域特有' },
  { key: '4B', value: '已报道的表型高度特异，但并非该基因或区域特有' },
  { key: '4C', value: '已报道的表型一致，但是不够特异或者有较高的遗传异质性' },
  { key: '4D', value: '已报道的表型与该基因或区域不一致' },
  {
    key: '4E',
    value:
      '已报道的表型高度特异而且与该基因或区域一致，但是遗传模式未知（不确定新发还是遗传自父母）'
  },
  { key: '4F', value: '3-4个共分离' },
  { key: '4G', value: '5-6个共分离' },
  { key: '4H', value: '7个或更多共分离' },
  { key: '4I', value: '在有一致的特异表型的家庭成员中，未发现该变异' },
  { key: '4J', value: '在先证者表型特异的前提下，在正常家庭成员中发现该变异' },
  { key: '4K', value: '先证者表型不够特异，在正常家庭成员中发现该变异' },
  { key: '4L', value: '与对照相比，在病例中的频率显著增加（表型一致、特异）' },
  {
    key: '4M',
    value: '与对照相比，在病例中的频率显著增加（表型不够一致、特异）'
  },
  { key: '4N', value: '病例与对照组频率无统计学差异' },
  { key: '4O', value: '与常见人群变异重叠' },
  { key: '5A', value: '参考步骤4中关于新发CNV的评分方法' },
  { key: '5B', value: '病人表型特异、明确，无家族史。CNV遗传自无症状的父母' },
  { key: '5C', value: '病人表型不特异，无家族史。CNV遗传自无症状的父母' },
  { key: '5D', value: 'CNV在病人家系中与表型共分离' },
  { key: '5E', value: '参考步骤4中关于不符合共分离的CNV的评分方法' },
  { key: '5F', value: '无遗传模式信息或信息不全' },
  {
    key: '5G',
    value: '无遗传模式或信息不全，病人表型不特异，但是与相似病例表型一致'
  },
  {
    key: '5H',
    value: '无遗传模式或信息不全，病人表型特异，但是与相似病例表型一致'
  }
]
export const DUP_evidences = [
  { key: '1A', value: '包含蛋白编码基因或者其它已知重要功能元件' },
  { key: '1B', value: '不包含蛋白编码基因或者其它已知重要功能元件' },
  { key: '2A', value: '完全覆盖已知TS基因/关键区域' },
  { key: '2B', value: '部分覆盖已知TS基因/关键区域' },
  { key: '2C', value: '完全被已知良性基因/区域覆盖，大小相似' },
  { key: '2D', value: '部分重叠已知良性基因/区域，不中断蛋白编码基因' },
  { key: '2E', value: '部分重叠已知良性基因/区域，中断蛋白编码基因' },
  { key: '2F', value: '包含已知良性基因/区域，不包含其它蛋白编码基因' },
  { key: '2G', value: '包含已知良性基因/区域，还包含其它蛋白编码基因' },
  { key: '2H', value: '完全包含HI基因' },
  { key: '2I', value: '两端断点都在同一个基因内（基因内CNV，可能导致LOF' },
  {
    key: '2J',
    value: '一个断点在HI基因内，患者表型未知或与该基因LOF表型不一致'
  },
  {
    key: '2K',
    value: '一个断点在HI基因内，患者表型高度特异或与该基因LOF表型一致'
  },
  { key: '2L', value: '两个或一个断点在基因内，没有确定的临床意义' },
  { key: '3A', value: '0-34个基因' },
  { key: '3B', value: '35-49个基因' },
  { key: '3C', value: '大于等于50个基因' },
  { key: '4A', value: '已报道的表型高度特异，而且属于该基因或区域特有' },
  { key: '4B', value: '已报道的表型高度特异，但并非该基因或区域特有' },
  { key: '4C', value: '已报道的表型一致，但是不够特异或者有较高的遗传异质性' },
  { key: '4D', value: '已报道的表型与该基因或区域不一致' },
  {
    key: '4E',
    value: '已报道的表型高度特异而且与该基因或区域一致，但是遗传模式未知'
  },
  { key: '4F', value: '3-4个共分离' },
  { key: '4G', value: '5-6个共分离' },
  { key: '4H', value: '7个或更多共分离' },
  { key: '4I', value: '在有一致的特异表型的家庭成员中，未发现该变异' },
  { key: '4J', value: '在先证者表型特异的前提下，在正常家庭成员中发现该变异' },
  { key: '4K', value: '先证者表型不够特异，在正常家庭成员中发现该变异' },
  { key: '4L', value: '与对照相比，在病例中的频率显著增加（表型一致、特异）' },
  {
    key: '4M',
    value: '与对照相比，在病例中的频率显著增加（表型不够一致、特异）'
  },
  { key: '4N', value: '病例与对照组频率无统计学差异' },
  { key: '4O', value: '与常见人群变异重叠' },
  { key: '5A', value: '参考步骤4中关于新发CNV的评分方法' },
  { key: '5B', value: '病人表型特异、明确，无家族史。CNV遗传自无症状的父母' },
  { key: '5C', value: '病人表型不特异，无家族史。CNV遗传自无症状的父母' },
  { key: '5D', value: 'CNV在病人家系中与表型共分离' },
  { key: '5E', value: '参考步骤4中关于不符合共分离的CNV的评分方法' },
  { key: '5F', value: '无遗传模式信息或信息不全' },
  {
    key: '5G',
    value: '无遗传模式或信息不全，病人表型不特异，但是与相似病例表型一致'
  },
  {
    key: '5H',
    value: '无遗传模式或信息不全，病人表型特异，但是与相似病例表型一致'
  }
]

export const ACMG_evidences_zh: NObject = {
  PVS1: '当一个疾病的致病机制为功能丧失（LOF）时，无功能变异（无义突变、移码突变、经典±1或2的剪接突变、起始密码子变异、单个或多个外显子缺失）。',
  PS1: '与先前已确定为致病性的变异有相同的氨基酸改变。例如：同一密码子，G>C或G>T改变均可导致缬氨酸→亮氨酸的改变。',
  PS2: '患者的新发变异（Denovo），且无家族史（经双亲验证）。注：仅仅确认父母还不够，还需注意捐卵、代孕、胚胎移植的差错等情况。',
  PS3: '体内、体外功能实验已明确会导致基因功能受损的变异。',
  PS4: '变异出现在患病群体中的频率显著高于对照群体。',
  PM1: '位于热点突变区域，和/或位于已知无良性变异的关键功能域（如酶的活性位点）。',
  PM2: 'ESP数据库、千人数据库、EXAC数据库中正常对照人群中未发现的变异（或隐性遗传病中极低频位点）。',
  PM3: '在隐性遗传病中，在反式位置上检测到致病变异（经家系验证）。',
  PM4: '非重复区框内插入/缺失或终止密码子丧失导致的蛋白质长度变化（插入、缺失的碱基数是3的整倍数）。',
  PM5: '新的错义突变导致氨基酸变化，此变异之前未曾报道，但是在同一位点，导致另外一种氨基酸的变异已经确认是致病性的，如：现在观察到的是Arg156Cys，而Arg156His是已知致病的。',
  PM6: '未经父母样本验证的新发变异（Denovo）。',
  PP1: '突变与疾病在家系中共分离（在家系多个患者中检测到此变异）注：如果有更多的证据，可作为更强的证据。',
  PP2: '对某个基因来说，如果这个基因的错义变异是造成某种疾病的原因，并且这个基因中良性变异所占的比例很小，在这样的基因中所发现的新的错义变异。',
  PP3: '多种统计方法预测出该变异会对基因或基因产物造成有害的影响，包括保守性预测、进化预测、剪接位点影响等。',
  PP4: '变异携带者的表型或家族史高度符合某种单基因遗传疾病。',
  PP5: '有可靠信誉来源的报告认为该变异为致病的，但证据尚不足以支持进行实验室独立评估。',
  BA1: 'ESP数据库、千人数据库、ExAC数据库中等位基因频率>5%的变异。',
  BS1: '等位基因频率大于疾病发病率。',
  BS2: '对于早期完全外显的疾病，在健康成年人中发现该变异（隐性遗传病发现纯合、显性遗传病发现杂合，或者X连锁半合子）。',
  BS3: '在体内外实验中确认对蛋白质功能和剪接没有影响的变异。',
  BS4: '在一个家系成员中缺乏共分离。',
  BP1: '已知一个疾病的致病原因是由于某基因的截短变异，在此基因中所发现的错义变异。',
  BP2: '在显性遗传病中又发现了另一条染色体上同一基因的一个已知致病变异，或者是任意遗传模式遗传病中又发现了同一条染色体上同一基因的一个已知致病变异。',
  BP3: '功能未知重复区域内的缺失/插入，同时没有导致基因编码框改变。',
  BP4: '多种统计方法预测出该变异会对基因或基因产物无影响，包括保守性预测、进化预测、剪接位点影响等。注：由于做预测时许多生物信息算法使用相同或非常相似的输入，每个算法不应该算作一个独立的标准。BP4在一个任何变异的评估中只能使用一次。',
  BP5: '在已经有另一分子致病原因的病例中发现的变异。',
  BP6: '有可靠信誉来源的报告认为该变异为良性的，但证据尚不足以支持进行实验室独立评估。',
  BP7: '同义变异且预测不影响剪接'
}

export const ACMG_evidences_en: NObject = {
  PVS1: 'When the pathogenic mechanism of a disease is loss of function (LOF), there is no functional variation (nonsense mutation, frameshift mutation, classical ±1 or 2 splicing mutation, start codon variation, one or more exon deletions).',

  PS1: 'It has the same amino acid alteration as the previously identified pathogenic variant. For example, for the same codon, changes in G>C or G>T can both lead to a change from valine to leucine. ',

  PS2: 'The patient has a new variant (Denovo), and there is no family history (verified by both parents). Note: Merely confirming the parents is not enough. Attention should also be paid to situations such as errors in egg donation, surrogacy, and embryo transfer. ',

  PS3: 'In vivo and in vitro functional experiments have clearly identified variations that can lead to impaired gene function.',

  PS4: 'The frequency of mutations in the affected population was significantly higher than that in the control group. ',

  PM1: 'Located in the hotspot mutation region and/or in the key functional domain known to have no benign variations (such as the active site of the enzyme). ',

  PM2: 'Variations not found in the normal control population in the ESP database, the thousand-person database, and the EXAC database (or extremely low-frequency loci in recessive genetic diseases). ',

  PM3: 'In recessive genetic disorders, pathogenic variations were detected at the trans position (verified by the family). ',

  PM4: 'Changes in protein length caused by insertion/deletion or loss of stop codons within the non-repetitive box (the number of inserted or deleted bases is an integer multiple of 3).',

  PM5: 'A new missense mutation leads to an amino acid change, which has not been reported before. However, at the same site, a variation of another amino acid has been confirmed to be pathogenic. For example, Arg156Cys is currently observed, while Arg156His is known to be pathogenic.',

  PM6: 'Denovo variations not verified by parental samples. ',

  PP1: 'The mutation and the disease were co-isolated in the family (this variation was detected in multiple patients in the family). Note: If there is more evidence, it can be regarded as stronger evidence. ',

  PP2: 'For a certain gene, if the missense variation of this gene is the cause of a certain disease and the proportion of benign variations in this gene is very small, the new missense variations discovered in such a gene. ',

  PP3: 'Multiple statistical methods have predicted that this variation will have harmful effects on genes or gene products, including conservation prediction, evolutionary prediction, splicing site influence, etc. ',

  PP4: 'The phenotype or family history of the variant carrier is highly consistent with a certain single-gene genetic disease.',

  PP5: 'Reports from reliable and reputable sources suggest that this variant is pathogenic, but the evidence is not yet sufficient to support an independent laboratory assessment.',

  BA1: 'Variations with allele frequencies >5% in the ESP database, the thousand-person database, and the ExAC database. ',

  BS1: 'The allele frequency is greater than the disease incidence rate. ',

  BS2: 'For diseases that are fully extranated in the early stage, this variation is found in healthy adults (homozygous in recessive genetic diseases, heterozygous in dominant genetic diseases, or X-linked hemizygotes). ',

  BS3: 'Confirm variations that have no effect on protein function and splicing in in vivo and in vitro experiments. ',

  BS4: 'There is a lack of co-separation among family members.',

  BP1: 'It is known that the cause of a disease is due to the truncation variation of a certain gene, and the missense variation found in this gene.',

  BP2: 'A known pathogenic variation of the same gene on another chromosome has been discovered in a dominant genetic disorder, or a known pathogenic variation of the same gene on the same chromosome has been discovered in any genetic pattern genetic disorder.',

  BP3: 'Deletion/insertion within the functionally unknown repetitive region without causing a change in the gene coding box. ',

  BP4: 'Multiple statistical methods have predicted that this variation will have no effect on the gene or its products, including conservation prediction, evolutionary prediction, splicing site influence, etc. Note: Since many bioinformatics algorithms use the same or very similar inputs when making predictions, each algorithm should not be regarded as an independent standard. BP4 can only be used once in the assessment of any variation. ',

  BP5: 'Variations found in cases where there is already another molecular cause of the disease. ',

  BP6: 'Reports from reliable and reputable sources suggest that this variation is benign, but the evidence is not sufficient to support an independent laboratory assessment. ',

  BP7: 'Synonymous variation and prediction does not affect splicing'
}

const ACMG3_1And3_2Panel = [
  'APC',
  'RET',
  'BRCA1',
  'BRCA2',
  'PALB2',
  'SDHD',
  'SDHAF2',
  'SDHC',
  'SDHB',
  'MAX',
  'TMEM127',
  'BMPR1A',
  'SMAD4',
  'TP53',
  'MLH1',
  'MSH2',
  'MSH6',
  'PMS2',
  'MEN1',
  'MUTYH',
  'NF2',
  'STK11',
  'PTEN',
  'RB1',
  'TSC1',
  'TSC2',
  'VHL',
  'WT1',
  'FBN1',
  'TGFBR1',
  'TGFBR2',
  'SMAD3',
  'ACTA2',
  'MYH11',
  'PKP2',
  'DSP',
  'DSC2',
  'TMEM43',
  'DSG2',
  'RYR2',
  'CASQ2',
  'TRDN',
  'TNNT2',
  'LMNA',
  'FLNC',
  'TTN',
  'BAG3',
  'DES',
  'RBM20',
  'TNNC1',
  'COL3A1',
  'LDLR',
  'APOB',
  'PCSK9',
  'MYH7',
  'MYBPC3',
  'TNNI3',
  'TPM1',
  'MYL3',
  'ACTC1',
  'PRKAG2',
  'MYL2',
  'KCNQ1',
  'KCNH2',
  'SCN5Ab',
  'CALM1',
  'CALM2',
  'CALM3',
  'BTD',
  'GLA',
  'OTC',
  'GAA',
  'HFE',
  'ACVRL1',
  'ENG',
  'RYR1',
  'CACNA1S',
  'HNF1A',
  'RPE65',
  'ATP7B',
  'TTR',
  'SCN5A'
]

const TumorPanel = [
  'AAGAB',
  'AARS1',
  'ABCA5',
  'ABCB11',
  'ABCB4',
  'ABCC6',
  'ABCC8',
  'ABL1',
  'ACAN',
  'ACD',
  'ACP5',
  'ACTB',
  'ACTG2',
  'ACVR1',
  'ACVR1B',
  'ACVRL1',
  'ADA',
  'ADA2',
  'ADAMTS3',
  'ADAR',
  'ADH5',
  'AGGF1',
  'AHCY',
  'AIP',
  'AKT1',
  'ALAD',
  'ALG5',
  'ALG9',
  'ALK',
  'ALX1',
  'ALX3',
  'ALX4',
  'ANAPC1',
  'ANTXR1',
  'ANTXR2',
  'AP2S1',
  'AP3D1',
  'APC',
  'APC2',
  'APPL1',
  'AR',
  'ARHGAP26',
  'ARID1A',
  'ARID1B',
  'ARID2',
  'ARL6IP6',
  'ARMC5',
  'ARSA',
  'ASCC1',
  'ASCL1',
  'ASL',
  'ASPSCR1',
  'ASXL1',
  'ATM',
  'ATP2A2',
  'ATP2B1',
  'ATP6V1B2',
  'ATP7A',
  'ATP7B',
  'ATR',
  'ATRX',
  'AURKA',
  'AXIN1',
  'AXIN2',
  'B3GALT6',
  'BAP1',
  'BARD1',
  'BAX',
  'BCHE',
  'BCL10',
  'BCL2',
  'BCL6',
  'BCR',
  'BDNF',
  'BICC1',
  'BIN1',
  'BIRC3',
  'BLK',
  'BLM',
  'BLNK',
  'BMP2',
  'BMP6',
  'BMPER',
  'BMPR1A',
  'BMPR1B',
  'BPTF',
  'BRAF',
  'BRCA1',
  'BRCA2',
  'BRD4',
  'BRIP1',
  'BTK',
  'BUB1',
  'BUB1B',
  'BUB3',
  'C1S',
  'C2CD3',
  'CACNA1S',
  'CALR',
  'CAPNS1',
  'CARD14',
  'CARMIL2',
  'CARS1',
  'CASP10',
  'CASP8',
  'CASR',
  'CASZ1',
  'CAT',
  'CBL',
  'CC2D2A',
  'CCBE1',
  'CCDC22',
  'CCM2',
  'CCND1',
  'CD19',
  'CD27',
  'CD28',
  'CD4',
  'CD70',
  'CD79A',
  'CD79B',
  'CD96',
  'CDC73',
  'CDH1',
  'CDH23',
  'CDK4',
  'CDKN1A',
  'CDKN1B',
  'CDKN1C',
  'CDKN2A',
  'CDKN2B',
  'CDKN2C',
  'CDON',
  'CEBPA',
  'CEL',
  'CEP120',
  'CEP57',
  'CHD6',
  'CHD7',
  'CHEK2',
  'CHIC2',
  'CHMP2B',
  'CHRNG',
  'CIB1',
  'CLCN2',
  'CLCNKB',
  'CLPB',
  'COG1',
  'COL11A2',
  'COL14A1',
  'COL17A1',
  'COL1A1',
  'COL2A1',
  'COL4A3',
  'COL4A4',
  'COL4A5',
  'COL4A6',
  'COL7A1',
  'COQ6',
  'CPLANE1',
  'CPLX1',
  'CPOX',
  'CR2',
  'CREB1',
  'CREBBP',
  'CRELD1',
  'CRIPTO',
  'CRKL',
  'CSF3R',
  'CTBP1',
  'CTC1',
  'CTHRC1',
  'CTLA4',
  'CTNNA1',
  'CTNNB1',
  'CTPS1',
  'CTR9',
  'CTRC',
  'CTSA',
  'CTSC',
  'CXCR4',
  'CYLD',
  'CYP11B1',
  'CYP11B2',
  'CYP26C1',
  'CYP2A6',
  'CYP2D6',
  'CYSLTR2',
  'DCC',
  'DCLRE1C',
  'DDB2',
  'DDR2',
  'DDX41',
  'DDX59',
  'DEF6',
  'DHCR24',
  'DHCR7',
  'DHH',
  'DHX37',
  'DIAPH1',
  'DICER1',
  'DIS3L2',
  'DISP1',
  'DKC1',
  'DLC1',
  'DLEC1',
  'DLK1',
  'DLL1',
  'DLST',
  'DNA2',
  'DNAJB11',
  'DNAJC21',
  'DNASE1L3',
  'DNM2',
  'DNMT3A',
  'DOCK8',
  'DPF2',
  'DPM1',
  'DPYSL5',
  'DUT',
  'DVL1',
  'DVL3',
  'DYNC2H1',
  'DYNC2LI1',
  'DZIP1L',
  'ECM1',
  'EDN1',
  'EDN3',
  'EFL1',
  'EGFR',
  'EIF2AK4',
  'EIF3F',
  'ELANE',
  'ELMO2',
  'ELP1',
  'ENG',
  'ENPP1',
  'EP300',
  'EPAS1',
  'EPCAM',
  'EPHB2',
  'EPHB4',
  'ERBB2',
  'ERBB3',
  'ERCC2',
  'ERCC3',
  'ERCC4',
  'ERCC5',
  'ERCC6',
  'ESCO2',
  'ESR1',
  'ETV6',
  'EVC',
  'EVC2',
  'EWSR1',
  'EXT1',
  'EXT2',
  'EXTL3',
  'EYA1',
  'F13A1',
  'F13B',
  'F5',
  'FAH',
  'FAM149B1',
  'FAM20A',
  'FAM20C',
  'FANCA',
  'FANCB',
  'FANCC',
  'FANCD2',
  'FANCE',
  'FANCF',
  'FANCG',
  'FANCI',
  'FANCL',
  'FANCM',
  'FAS',
  'FASLG',
  'FAT4',
  'FBXO28',
  'FCHO1',
  'FCN3',
  'FDPS',
  'FERMT1',
  'FGF3',
  'FGF8',
  'FGFR1',
  'FGFR2',
  'FGFR3',
  'FGFRL1',
  'FH',
  'FIBP',
  'FLCN',
  'FLI1',
  'FLNA',
  'FLT3',
  'FLT4',
  'FOCAD',
  'FOXC2',
  'FOXE1',
  'FOXH1',
  'FOXI1',
  'FOXO1',
  'FOXP1',
  'FUZ',
  'FZD2',
  'G6PC1',
  'GABRD',
  'GANAB',
  'GAS1',
  'GATA1',
  'GATA2',
  'GATA4',
  'GBA1',
  'GCDH',
  'GCGR',
  'GCK',
  'GCM2',
  'GDF2',
  'GDF5',
  'GDNF',
  'GFI1',
  'GIMAP5',
  'GINS1',
  'GJA1',
  'GJB2',
  'GJB3',
  'GJB4',
  'GJB6',
  'GLI1',
  'GLI2',
  'GLI3',
  'GNA11',
  'GNA14',
  'GNAI3',
  'GNAQ',
  'GNAS',
  'GNB1',
  'GNPTAB',
  'GPC3',
  'GPC4',
  'GPC6',
  'GPR101',
  'GPR143',
  'GPR161',
  'GPR35',
  'GREM1',
  'GRN',
  'GTF2E2',
  'GTF2H5',
  'H19',
  'H4C5',
  'H4C9',
  'HABP2',
  'HACE1',
  'HAVCR2',
  'HAX1',
  'HBB',
  'HDAC4',
  'HEATR3',
  'HEPACAM',
  'HFE',
  'HLA-DQA1',
  'HLA-DQB1',
  'HLA-DRB1',
  'HMBS',
  'HMMR',
  'HNF1A',
  'HNF1B',
  'HNF4A',
  'HOXD13',
  'HPGD',
  'HRAS',
  'HS2ST1',
  'HSCB',
  'HSPA9',
  'HSPG2',
  'ICOS',
  'ICOSLG',
  'IDH1',
  'IDH2',
  'IFIH1',
  'IFNG',
  'IFT140',
  'IGF2',
  'IGF2R',
  'IGH',
  'IGHG2',
  'IGHM',
  'IGKC',
  'IGLL1',
  'IKBKG',
  'IKZF1',
  'IKZF3',
  'IL12A',
  'IL12RB1',
  'IL1B',
  'IL1RN',
  'IL2RG',
  'IL6',
  'IL6ST',
  'IL7',
  'IL7R',
  'ING1',
  'INPP5E',
  'INS',
  'INTU',
  'IPO8',
  'IRF1',
  'IRF5',
  'ITK',
  'IVNS1ABP',
  'JAG1',
  'JAK2',
  'KANSL1',
  'KARS1',
  'KAT6B',
  'KCNAB2',
  'KCNE3',
  'KCNH1',
  'KCNJ10',
  'KCNJ11',
  'KCNN3',
  'KCNQ1',
  'KCNQ1OT1',
  'KCTD1',
  'KDM1A',
  'KDM6A',
  'KDM6B',
  'KDR',
  'KDSR',
  'KEAP1',
  'KIAA0586',
  'KIAA0753',
  'KIF11',
  'KIF1B',
  'KIF7',
  'KIT',
  'KLF11',
  'KLF6',
  'KLHDC8B',
  'KLLN',
  'KMT2D',
  'KRAS',
  'KRIT1',
  'KRT1',
  'KRT10',
  'KRT14',
  'KRT16',
  'KRT17',
  'KRT5',
  'KRT6A',
  'KRT6B',
  'L2HGDH',
  'LAMA3',
  'LAMB3',
  'LAMC2',
  'LBX1',
  'LEMD3',
  'LETM1',
  'LIG4',
  'LIN28B',
  'LMNA',
  'LMO1',
  'LMOD1',
  'LPP',
  'LRBA',
  'LRP1',
  'LRRC8A',
  'LSM11',
  'LUZP1',
  'LZTR1',
  'LZTS1',
  'MAD1L1',
  'MAD2L2',
  'MAFA',
  'MAGT1',
  'MALT1',
  'MAN2C1',
  'MAP2K1',
  'MAP2K2',
  'MAP3K1',
  'MAP3K8',
  'MAPK1',
  'MAPRE2',
  'MAPT',
  'MAX',
  'MBD4',
  'MBTPS2',
  'MC1R',
  'MC2R',
  'MCC',
  'MCM4',
  'MCM9',
  'MDH2',
  'MDM2',
  'MDM4',
  'MEFV',
  'MEG3',
  'MEN1',
  'MET',
  'MFN2',
  'MGAT2',
  'MGMT',
  'MINPP1',
  'MITF',
  'MLH1',
  'MLH3',
  'MLLT10',
  'MMEL1',
  'MMP1',
  'MMP23B',
  'MN1',
  'MNX1',
  'MPL',
  'MPLKIP',
  'MPV17',
  'MRAP',
  'MRAS',
  'MRE11',
  'MSH2',
  'MSH3',
  'MSH6',
  'MSL3',
  'MSR1',
  'MST1',
  'MST1R',
  'MSTO1',
  'MSX2',
  'MT-ND5',
  'MT-RNR1',
  'MT-TF',
  'MT-TH',
  'MT-TK',
  'MT-TL1',
  'MT-TP',
  'MT-TQ',
  'MT-TS1',
  'MT-TS2',
  'MTAP',
  'MTMR14',
  'MTOR',
  'MUC5B',
  'MUTYH',
  'MVD',
  'MVK',
  'MXI1',
  'MYC',
  'MYCN',
  'MYD88',
  'MYF6',
  'MYH11',
  'MYH8',
  'MYLK',
  'MYO1H',
  'MYSM1',
  'NAB2',
  'NAF1',
  'NAGS',
  'NBEAL2',
  'NBN',
  'NDP',
  'NDUFAF6',
  'NEK1',
  'NEK8',
  'NEK9',
  'NELFA',
  'NEUROD1',
  'NF1',
  'NF2',
  'NFATC2',
  'NFIX',
  'NHP2',
  'NKX2-1',
  'NLRP1',
  'NNT',
  'NOD2',
  'NODAL',
  'NOP10',
  'NOTCH1',
  'NOTCH3',
  'NPAT',
  'NPM1',
  'NQO2',
  'NR0B1',
  'NR3C1',
  'NR4A3',
  'NR5A1',
  'NRAS',
  'NSD1',
  'NSD2',
  'NSUN2',
  'NTHL1',
  'NTRK1',
  'NUP214',
  'NUTM1',
  'OCA2',
  'OCRL',
  'OFD1',
  'OGG1',
  'OPCML',
  'PALB2',
  'PALLD',
  'PARN',
  'PAX3',
  'PAX4',
  'PAX6',
  'PAX7',
  'PBRM1',
  'PCNA',
  'PDCD1',
  'PDCD10',
  'PDE11A',
  'PDE6D',
  'PDGFB',
  'PDGFRA',
  'PDGFRB',
  'PDGFRL',
  'PDPN',
  'PDX1',
  'PERP',
  'PGM3',
  'PHB1',
  'PHF21A',
  'PHKA2',
  'PHKB',
  'PHKG2',
  'PHOX2B',
  'PICALM',
  'PIEZO2',
  'PIGG',
  'PIGL',
  'PIK3CA',
  'PIK3CD',
  'PIK3R1',
  'PKD1',
  'PKD2',
  'PKHD1',
  'PLA2G2A',
  'PLAG1',
  'PLCB4',
  'PLCD1',
  'PMS1',
  'PMS2',
  'PNP',
  'POFUT1',
  'POGLUT1',
  'POLD1',
  'POLE',
  'POLH',
  'POLR1B',
  'POLR1C',
  'POLR1D',
  'POR',
  'PORCN',
  'POT1',
  'POU2AF1',
  'POU6F2',
  'PPM1D',
  'PPOX',
  'PPP1CB',
  'PPP2R1B',
  'PRCC',
  'PRDM10',
  'PRDM16',
  'PRF1',
  'PRKACA',
  'PRKACB',
  'PRKAR1A',
  'PRKCD',
  'PRKCZ',
  'PRKN',
  'PRLR',
  'PSAP',
  'PSEN1',
  'PSENEN',
  'PSMB10',
  'PTCH1',
  'PTCH2',
  'PTEN',
  'PTH1R',
  'PTPN11',
  'PTPN12',
  'PTPN3',
  'PTPN6',
  'PTPRC',
  'PTPRJ',
  'PUF60',
  'PYGL',
  'RABL3',
  'RAD21',
  'RAD50',
  'RAD51',
  'RAD51C',
  'RAD51D',
  'RAD54B',
  'RAD54L',
  'RAF1',
  'RAG1',
  'RAG2',
  'RARA',
  'RASA1',
  'RASA2',
  'RASGRP1',
  'RB1',
  'RB1CC1',
  'RBM8A',
  'RECQL4',
  'RERE',
  'REST',
  'RET',
  'RFWD3',
  'RHBDF2',
  'RHOH',
  'RIT1',
  'RMRP',
  'RNASEH2A',
  'RNASEH2B',
  'RNASEH2C',
  'RNASEL',
  'RNF113A',
  'RNF139',
  'RNF31',
  'RNF43',
  'RNF6',
  'RNU4-2',
  'RNU7-1',
  'ROS1',
  'RPA1',
  'RPGRIP1L',
  'RPL10',
  'RPL11',
  'RPL15',
  'RPL18',
  'RPL26',
  'RPL27',
  'RPL31',
  'RPL35',
  'RPL35A',
  'RPL5',
  'RPL8',
  'RPL9',
  'RPS10',
  'RPS14',
  'RPS15A',
  'RPS17',
  'RPS19',
  'RPS20',
  'RPS24',
  'RPS26',
  'RPS27',
  'RPS28',
  'RPS29',
  'RPS7',
  'RRAS',
  'RRAS2',
  'RSPO1',
  'RSPRY1',
  'RTEL1',
  'RTL1',
  'RUNX1',
  'RYR1',
  'SAMD9',
  'SAMD9L',
  'SAMHD1',
  'SASH1',
  'SASH3',
  'SBDS',
  'SCARB2',
  'SCN10A',
  'SCN11A',
  'SCN4A',
  'SCN9A',
  'SDHA',
  'SDHAF2',
  'SDHB',
  'SDHC',
  'SDHD',
  'SEC23A',
  'SEC23B',
  'SEC61A1',
  'SEMA4A',
  'SEMA4D',
  'SERPINA1',
  'SETBP1',
  'SF3B1',
  'SFTPA2',
  'SFTPC',
  'SH2B3',
  'SH2D1A',
  'SH3GL1',
  'SHH',
  'SHOC2',
  'SHOX',
  'SIX1',
  'SIX3',
  'SIX6',
  'SKI',
  'SKIC2',
  'SKIC3',
  'SLC12A3',
  'SLC17A9',
  'SLC25A11',
  'SLC25A13',
  'SLC26A2',
  'SLC26A4',
  'SLC2A2',
  'SLC37A4',
  'SLC45A2',
  'SLC67A1',
  'SLC6A17',
  'SLCO2A1',
  'SLX4',
  'SMAD4',
  'SMAD7',
  'SMARCA4',
  'SMARCAD1',
  'SMARCAL1',
  'SMARCB1',
  'SMARCC2',
  'SMARCD1',
  'SMARCD2',
  'SMARCE1',
  'SMO',
  'SMPD1',
  'SNAI2',
  'SOCS1',
  'SOS1',
  'SOS2',
  'SOX11',
  'SOX2',
  'SOX4',
  'SOX5',
  'SOX6',
  'SOX9',
  'SPEN',
  'SPI1',
  'SPIB',
  'SPINK1',
  'SPRED1',
  'SPRED2',
  'SPRTN',
  'SPTBN1',
  'SQSTM1',
  'SRC',
  'SRD5A3',
  'SRGAP1',
  'SRP19',
  'SRP54',
  'SRP72',
  'SRSF2',
  'SRY',
  'STAC3',
  'STAG3',
  'STAR',
  'STAT1',
  'STAT3',
  'STAT4',
  'STAT6',
  'STIM1',
  'STK11',
  'STK4',
  'STS',
  'SUFU',
  'SYK',
  'TAF1',
  'TAF15',
  'TAL1',
  'TAL2',
  'TARS1',
  'TBC1D24',
  'TBC1D32',
  'TBX2',
  'TBXT',
  'TCF3',
  'TCF4',
  'TCIRG1',
  'TCOF1',
  'TCTN3',
  'TEK',
  'TERC',
  'TERF2IP',
  'TERT',
  'TET2',
  'TFAP2A',
  'TFE3',
  'TG',
  'TGFBR1',
  'TGFBR2',
  'TGIF1',
  'THPO',
  'THSD1',
  'TIAM1',
  'TINF2',
  'TJP2',
  'TLR2',
  'TMC6',
  'TMC8',
  'TMEM106B',
  'TMEM107',
  'TMEM127',
  'TMEM216',
  'TMEM231',
  'TMEM67',
  'TNFRSF10B',
  'TNFRSF13B',
  'TNFRSF13C',
  'TNFRSF1B',
  'TNFRSF4',
  'TNFRSF9',
  'TNFSF15',
  'TNPO3',
  'TOPORS',
  'TP53',
  'TP63',
  'TPP2',
  'TRAF7',
  'TRAPPC14',
  'TREM2',
  'TREX1',
  'TRIM28',
  'TRIM37',
  'TRIP13',
  'TRPM3',
  'TRPS1',
  'TRPV3',
  'TSC1',
  'TSC2',
  'TSR2',
  'TTC7A',
  'TUBB',
  'TULP3',
  'TWIST1',
  'TXNRD2',
  'TYMS',
  'TYR',
  'TYROBP',
  'UBA1',
  'UBE2T',
  'UBE4B',
  'UROD',
  'UROS',
  'USB1',
  'USF3',
  'USP48',
  'USP8',
  'USP9X',
  'VAMP7',
  'VANGL1',
  'VANGL2',
  'VCP',
  'VHL',
  'VPS16',
  'VPS35L',
  'WAS',
  'WASHC5',
  'WDPCP',
  'WIPF1',
  'WNT10A',
  'WNT5A',
  'WRAP53',
  'WRN',
  'WT1',
  'WWOX',
  'XIAP',
  'XPA',
  'XPC',
  'XRCC2',
  'XRCC3',
  'XRCC4',
  'YY1',
  'ZAP70',
  'ZEB2',
  'ZFHX3',
  'ZFPM2',
  'ZFTA',
  'ZFX',
  'ZIC2',
  'ZNRF3',
  'ZSWIM6'
]

interface ReportValue {
  sample: Sample | null
  patient: Patients | null
  other: any | null
}

export const specialInheritance = [
  {
    acronym: 'AD',
    zh: '常染色体显性遗传',
    en: 'Autosomal dominant inheritance'
  },
  {
    acronym: 'AR',
    zh: '常染色体隐性遗传',
    en: 'Autosomal recessive inheritance'
  },
  {
    acronym: 'XD',
    zh: 'X连锁显性遗传',
    en: 'X-linked dominant inheritance'
  },
  {
    acronym: 'XR',
    zh: 'X连锁隐性遗传',
    en: 'X-linked recessive inheritance'
  },
  {
    acronym: 'X-linked',
    zh: 'X连锁遗传',
    en: 'X-linked inheritance'
  },
  {
    acronym: 'Y',
    zh: 'Y连锁遗传',
    en: 'Y-linked inheritance'
  },
  {
    acronym: 'Gi',
    zh: '性连锁遗传',
    en: 'Gonosomal inheritance'
  },
  {
    acronym: 'Mi',
    zh: '线粒体遗传',
    en: 'Mitochondrial inheritance'
  },
  {
    acronym: 'AD(ADIP)',
    zh: '具有不完全外显的常染色体显性遗传',
    en: 'Autosomal dominant inheritance Incomplete penetrance'
  },
  {
    acronym: 'Smu',
    zh: '体细胞突变',
    en: 'Somatic mutation'
  },
  {
    acronym: 'Smo',
    zh: '体细胞嵌合体',
    en: 'Somatic mosaicism'
  },
  {
    acronym: 'H',
    zh: '异质性',
    en: 'Heterogeneous'
  },
  {
    acronym: 'FP',
    zh: '家族遗传背景',
    en: 'Familial predisposition'
  },
  {
    acronym: 'H',
    zh: '异质性',
    en: 'Heterogeneous'
  },
  {
    acronym: 'FP',
    zh: '家族遗传背景',
    en: 'Familial predisposition'
  },
  {
    acronym: 'CGS',
    zh: '连续基因综合症',
    en: 'Contiguous gene syndrome'
  },
  {
    acronym: 'ADCGS',
    zh: '常染色体显性遗传连续基因综合症',
    en: 'Autosomal dominant contiguous gene syndrome'
  },
  {
    acronym: 'Mu',
    zh: '多因素遗传',
    en: 'Multifactorial inheritance'
  },
  {
    acronym: 'Di',
    zh: '二基因遗传',
    en: 'Digenic inheritance'
  },
  {
    acronym: 'DD',
    zh: '二基因显性遗传',
    en: 'Digenic dominant'
  },
  {
    acronym: 'DR',
    zh: '二基因隐性遗传',
    en: 'Digenic recessive'
  },
  {
    acronym: 'Oi',
    zh: '寡基因遗传',
    en: 'Oliggenic inheritance'
  },
  {
    acronym: 'Pi',
    zh: '多基因遗传',
    en: 'Polygenic inheritance'
  },
  {
    acronym: 'ADMI',
    zh: '常染色体显性遗传伴母系印记',
    en: 'Autosomal dominant inheritance with maternal imprinting'
  },
  {
    acronym: 'ADPI',
    zh: '常染色体显性遗传伴父系印记',
    en: 'Autosomal dominant inheritance with paternal imprinting'
  },
  {
    acronym: 'ADSCM',
    zh: '常染色体显性遗传体细胞突变',
    en: 'Autosomal dominant somatic cell mutation'
  },
  {
    acronym: 'SIAD',
    zh: '限性常染色体显性遗传',
    en: 'Sex-limited autosomal dominant'
  },
  {
    acronym: 'MLAD',
    zh: '限男性常染色体显性遗传',
    en: 'Male-limited autosomal dominant'
  },
  {
    acronym: 'GA',
    zh: '遗传早现',
    en: 'Genetic anticipation'
  },
  {
    acronym: 'ICB',
    zh: '遗传性染色体不平衡',
    en: 'Inherited chromosomal imbalance'
  },
  {
    acronym: 'IC',
    zh: '个案报道',
    en: 'Isolated cases'
  },
  {
    acronym: 'S',
    zh: '散发',
    en: 'Sporadic'
  },
  {
    acronym: 'SMu',
    zh: '体细胞遗传',
    en: 'Sporadic'
  }
]

// -1较低，0稍低，1正常
const set = [
  {
    gene: 'FokI',
    rsId: 'rs2228570',
    ref: 'A',
    alt: 'G',
    result: 'A/A',
    data: 1
  },
  {
    gene: 'FokI',
    rsId: 'rs2228570',
    ref: 'A',
    alt: 'G',
    result: 'A/G',
    data: 0
  },
  {
    gene: 'FokI',
    rsId: 'rs2228570',
    ref: 'A',
    alt: 'G',
    result: 'G/G',
    data: -1
  },
  {
    gene: 'ApaI',
    rsId: 'rs7975232',
    ref: 'C',
    alt: 'A',
    result: 'C/C',
    data: 1
  },
  {
    gene: 'ApaI',
    rsId: 'rs7975232',
    ref: 'C',
    alt: 'A',
    result: 'C/A',
    data: 0
  },
  {
    gene: 'ApaI',
    rsId: 'rs7975232',
    ref: 'C',
    alt: 'A',
    result: 'A/A',
    data: -1
  },
  {
    gene: 'BsmI',
    rsId: 'rs2228570',
    ref: 'C',
    alt: 'T',
    result: 'C/C',
    data: 1
  },
  {
    gene: 'BsmI',
    rsId: 'rs2228570',
    ref: 'C',
    alt: 'T',
    result: 'C/T',
    data: 0
  },
  {
    gene: 'BsmI',
    rsId: 'rs2228570',
    ref: 'C',
    alt: 'T',
    result: 'T/T',
    data: -1
  },
  {
    gene: 'TaqI',
    rsId: 'rs2228570',
    ref: 'A',
    alt: 'G',
    result: 'A/A',
    data: 1
  },
  {
    gene: 'TaqI',
    rsId: 'rs2228570',
    ref: 'A',
    alt: 'G',
    result: 'A/G',
    data: 0
  },
  {
    gene: 'TaqI',
    rsId: 'rs2228570',
    ref: 'A',
    alt: 'G',
    result: 'G/G',
    data: -1
  },
  {
    gene: 'G66567A',
    rsId: 'rs2228570',
    ref: 'C',
    alt: 'T',
    result: 'C/C',
    data: 1
  },
  {
    gene: 'G66567A',
    rsId: 'rs2228570',
    ref: 'C',
    alt: 'T',
    result: 'C/T',
    data: 0
  },
  {
    gene: 'G66567A',
    rsId: 'rs2228570',
    ref: 'C',
    alt: 'T',
    result: 'T/T',
    data: -1
  }
]

// 无风险
export const noRisk = [
  'MTHFR_CC/MTHFR_AA/MTRR_AA',
  'MTHFR_CC/MTHFR_AA/MTRR_AG',
  'MTHFR_CC/MTHFR_AA/MTRR_GG',
  'MTHFR_CC/MTHFR_AC/MTRR_AA'
]

// 低风险
export const lowRisk = [
  'MTHFR_CC/MTHFR_AC/MTRR_AG',
  'MTHFR_CC/MTHFR_AC/MTRR_GG',
  'MTHFR_CC/MTHFR_CC/MTRR_AA',
  'MTHFR_CT/MTHFR_AA/MTRR_AA',
  'MTHFR_CT/MTHFR_AA/MTRR_AG',
  'MTHFR_CT/MTHFR_AA/MTRR_GG',
  'MTHFR_CT/MTHFR_AC/MTRR_AA',
  'MTHFR_CT/MTHFR_AC/MTRR_AG',
  'MTHFR_CT/MTHFR_AC/MTRR_GG',
  'MTHFR_CT/MTHFR_CC/MTRR_AA',
  'MTHFR_TT/MTHFR_AA/MTRR_AA',
  'MTHFR_TT/MTHFR_AC/MTRR_AA'
]

// 中风险
export const mediumRisk = [
  'MTHFR_CC/MTHFR_CC/MTRR_AG',
  'MTHFR_CC/MTHFR_CC/MTRR_GG',
  'MTHFR_CT/MTHFR_CC/MTRR_AG',
  'MTHFR_CT/MTHFR_CC/MTRR_GG',
  'MTHFR_TT/MTHFR_AC/MTRR_AG',
  'MTHFR_TT/MTHFR_AC/MTRR_GG',
  'MTHFR_TT/MTHFR_CC/MTRR_AA'
]

// 高风险
export const highRisk = [
  'MTHFR_TT/MTHFR_AA/MTRR_AG',
  'MTHFR_TT/MTHFR_AA/MTRR_GG',
  'MTHFR_TT/MTHFR_CC/MTRR_AG',
  'MTHFR_TT/MTHFR_CC/MTRR_GG'
]

const CurrentReport = React.forwardRef(
  (
    props: {
      current: number
      analysisInfo: any
      name: any
      type?: 'sample' | 'analysis' | null
      id?: string
    },
    ref
  ) => {
    const { t } = useTranslation()

    const router = useRouter()

    let { id } = router.query
    let type = router.asPath.includes('/samples') ? 'sample' : 'analysis'

    if (props.id && props.type) {
      type = props.type

      id = props.id
    }
    const [diaOpen, setOpen] = React.useState(false)
    const [signature, setSignature] = React.useState('')
    const [signature2, setSignature2] = React.useState('')
    const [signature3, setSignature3] = React.useState('')
    const [signature4, setSignature4] = React.useState('')
    const [chatText, setChatText] = React.useState<string>('')
    const [samples, setSamples] = React.useState<any[]>([])
    const [hg19jsonData, setHg19JsonData] = React.useState<any[]>([])
    const [hg38jsonData, setHg38JsonData] = React.useState<any[]>([])
    const [report, setRepoet] = React.useState<Reports | null>()
    const [reportsVariants, setReportsVariants] = React.useState<any[]>([])
    const [reportValue, setReportValue] = React.useState<ReportValue>({
      sample: null,
      patient: null,
      other: null
    })
    const ChatItem = React.useRef<any>()
    const messageRef = React.useRef<any>()
    const wordReportRef = React.useRef<any>()
    const wordDomReportRef = React.useRef<any>()
    const [articles, setArticles] = React.useState<any[]>([])
    const [KeyFindingLitVarArticles, setKeyFindingLitVarArticles] =
      React.useState<any[]>()
    const [
      IncidentalDiscoveryLitVarArticles,
      setIncidentalDiscoveryLitVarArticles
    ] = React.useState<any[]>()
    const [detectionMTVariationList, setDetectionMTVariationList] =
      React.useState<Variation[]>([])
    const [detectionTumorVariationList, setDetectionTumorVariationList] =
      React.useState<Variation[]>([])
    const [detectionRawDataVariationList, setDetectionRawDataVariationList] =
      React.useState<Variation[]>([])
    const slateRef = React.useRef<any>()
    const containerRef = React.useRef<any>()
    const [variantDetail, setVariantDetails] = React.useState<
      VariantDetail | any
    >()
    const [rohList, setRohList] = React.useState<IVariantRohData[]>([])
    const [sanger, setSanger] = React.useState<any[]>([])
    const [rohFilterValue, setRohFilterValue] = React.useState({
      size: 3,
      nbVariants: 0,
      percentageHomozygosity: 90
    })
    const [setsValue, setSetsValue] = React.useState<NObject>({
      // -1较低，0稍低，1正常
      FokISet: {
        key: 'FokI',
        label: 'AA',
        value: 1
      },
      ApaISet: {
        key: 'ApaI',
        label: 'CC',
        value: 1
      },
      BsmISet: {
        key: 'BsmI',
        label: 'CC',
        value: 1
      },
      TaqISet: {
        key: 'TaqI',
        label: 'AA',
        value: 1
      },
      G66567ASet: {
        key: 'G66567A',
        label: 'CC',
        value: 1
      }
    })
    const [userAcmgData, setUserAcmgData] = React.useState<UserACMGLogs[]>([])

    const [thalassemia, setThalassemia] = React.useState({
      HBA1x: [] as string[],
      HBA1y: [] as string[],
      HBA2x: [] as string[],
      HBA2y: [] as string[],
      HBB: [] as string[]
    })
    const [setsValue2, setSetsValue2] = React.useState<NObject>({
      C677T: {
        key: 'MTHFR',
        label: 'CC',
        value: 'C677T'
      },
      A1298C: {
        key: 'MTHFR',
        label: 'AA',
        value: 'A1298C'
      },
      A66G: {
        key: 'MTRR',
        label: 'AA',
        value: 'A66G'
      }
    })
    const [radioValue, setRadioValue] = React.useState('')
    const [radioValue1, setRadioValue1] = React.useState('')
    const [radioValue2, setRadioValue2] = React.useState('')
    const [checkedValue, setCheckedValue] = React.useState(false)
    const [isRoh, setIsRoh] = React.useState(false)
    const [isACMGSF, setACMGSF] = React.useState(false)

    // ** Hooks
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles: File[]) => {
        if (acceptedFiles.length) {
          const file = acceptedFiles[0]

          if (file) {
            const reader = new FileReader()

            reader.onload = (e: any) => {
              setSignature4(e.target.result)
              const params = {
                ...report,
                reportJson: null,
                updatedAt: new Date()
              }
              if (report && report.metadata && isJson(report.metadata)) {
                const value = JSON.parse(report.metadata)

                value.signature = signature

                value.signature2 = signature2

                value.signature3 = signature3
                value.signature4 = e.target.result

                params.metadata = JSON.stringify(value)
              }

              updateReportsMutation.mutateAsync({
                ...params,
                changeData: []
              })
            }

            reader.onerror = (error) => {
              console.error('Error reading file:', error)
            }

            reader.readAsDataURL(file) // 读取文件为 Data URL (Base64)
          }
        }
      }
    })

    React.useEffect(() => {
      const fetchData = async (url: string, setData: any) => {
        try {
          const response = await fetch(url)
          const text = await response.text()

          // Split the text by new lines to get rows
          const rows = text.split('\n').filter((row) => row.trim() !== '')

          // Initialize an array to hold JSON objects
          const jsonData = []

          // Get headers from the first row
          const headers = rows[0].split('\t').map((header) => header.trim())

          // Iterate over the remaining rows and create JSON objects
          for (let i = 1; i < rows.length; i++) {
            const values = rows[i].split('\t').map((value) => value.trim())
            const jsonObject: NObject = {}

            headers.forEach((header, index) => {
              jsonObject[header] = values[index]
            })

            jsonData.push(jsonObject)
          }

          // Set the state with the JSON data
          setData(jsonData)
        } catch (error) {
          console.error('Error fetching or parsing TSV file:', error)
        }
      }

      if (
        report &&
        (report.templatePath === '7' ||
          report.templatePath === '6' ||
          report?.templatePath === '8' ||
          report?.templatePath === '9' ||
          report?.templatePath === '11' ||
          report?.templatePath === '13' ||
          report?.templatePath === '21' ||
          report?.templatePath === '22' ||
          report?.templatePath === '23')
      ) {
        if (props.analysisInfo.genomeBuild === 'hg19')
          fetchData('/GRCh37_cytoband.tsv', setHg19JsonData)
        else fetchData('/GRCh38_cytoband.tsv', setHg38JsonData)

        if (
          report.templatePath === '7' ||
          report.templatePath === '6' ||
          report.templatePath === '22'
        ) {
          queryMTVariants.mutateAsync(id as any)

          queryRawDataVariants.mutateAsync(id as any)
        }
        if (report.templatePath === '21') {
          queryRawDataVariants.mutateAsync(id as any)
        }
        if (report.templatePath === '23') {
          queryTumorVariants.mutateAsync(id as any)
        }
      }
    }, [report, props.analysisInfo.genomeBuild, id])

    const chromosomeData = React.useMemo(() => {
      if (hg19jsonData && hg19jsonData.length) {
        return hg19jsonData
      } else if (hg38jsonData && hg38jsonData.length) {
        return hg38jsonData
      } else return []
    }, [hg19jsonData, hg38jsonData])

    const handleClickOpen = () => {
      setOpen(true)
    }

    const switchGender = (gender: string) => {
      switch (gender) {
        case 'mother':
          return t('mother')
        case 'father':
          return t('father')
        case 'affected_child':
          return t('proband')
      }
    }

    const handlePrint = useReactToPrint({
      content: () => containerRef.current,
      pageStyle: `
          @page {
            size: A4;
            margin: 0;
          }
          @media print {
            body, html {
              height: auto;
              margin: 0;
            }
            body{
              zoom: 80%;
            }
            img{
              max-width: 100% !important;
              height: auto !important;
              page-break-inside: auto;
              break-inside: auto;
            }
            .header3-genetic{
                font-size: 20px;
                background-color: rgb(58, 159, 139);
                color: red;
                padding: 5px 0px 5px 5px;
                margin: 15px 0px;
                display: flex;
                align-items: start;
                justify-content: start;
            }
          }`,
      removeAfterPrint: true,
      documentTitle: `${props.name?.name}.pdf`
    })

    const handleExportThalassemia = () => {
      const column = [
        {
          title: 'Disease type',
          key: 'type'
        },
        {
          title: 'Mutant gene',
          key: 'gene'
        },
        {
          title: 'Nucleotide changes',
          key: 'changes'
        },
        {
          title: 'Chromosome position',
          key: 'chrom'
        },
        {
          title: 'Result',
          key: 'result'
        }
      ]
      const data = []
      const groupSize = 3

      const HBB = reportsVariants.find((item) => item.gene === 'HBB')

      const list = [
        {
          type: 'α thalassemia',
          gene: 'HBA1',
          changes: `${
            thalassemia &&
            thalassemia.HBA1x &&
            thalassemia.HBA1x.length &&
            thalassemia.HBA1x[0].includes('//')
              ? thalassemia.HBA1x[0].split('//')[0]
              : '-'
          }/${
            thalassemia &&
            thalassemia.HBA1y &&
            thalassemia.HBA1y.length &&
            thalassemia.HBA1y[0].includes('//')
              ? thalassemia.HBA1y[0].split('//')[0]
              : '-'
          }`,
          chrom: `${
            thalassemia &&
            thalassemia.HBA1x &&
            thalassemia.HBA1x.length &&
            thalassemia.HBA1x[0].includes('//')
              ? thalassemia.HBA1x[0].split('//')[1]
              : '-'
          }/${
            thalassemia &&
            thalassemia.HBA1y &&
            thalassemia.HBA1y.length &&
            thalassemia.HBA1y[0].includes('//')
              ? thalassemia.HBA1y[0].split('//')[1]
              : '-'
          }`,
          result: ''
        },
        {
          type: 'α thalassemia',
          gene: 'HBA2',
          changes: `${
            thalassemia &&
            thalassemia.HBA2x &&
            thalassemia.HBA2x.length &&
            thalassemia.HBA2x[0].includes('//')
              ? thalassemia.HBA2x[0].split('//')[0]
              : '-'
          }/${
            thalassemia &&
            thalassemia.HBA2y &&
            thalassemia.HBA2y.length &&
            thalassemia.HBA2y[0].includes('//')
              ? thalassemia.HBA2y[0].split('//')[0]
              : '-'
          }`,
          chrom: `${
            thalassemia &&
            thalassemia.HBA2x &&
            thalassemia.HBA2x.length &&
            thalassemia.HBA2x[0].includes('//')
              ? thalassemia.HBA2x[0].split('//')[1]
              : '-'
          }/${
            thalassemia &&
            thalassemia.HBA2y &&
            thalassemia.HBA2y.length &&
            thalassemia.HBA2y[0].includes('//')
              ? thalassemia.HBA2y[0].split('//')[1]
              : '-'
          }`,
          result: ''
        },
        {
          type: 'β thalassemia',
          gene: 'HBB',
          changes: HBB ? `${HBB.c_nomen}(${HBB.p_nomen})` : '-',
          chrom: HBB ? `chr${HBB.chrom}:${HBB.pos}` : '-',
          result: ''
        }
      ]

      for (let i = 0; i < list.length; i += groupSize) {
        const group = list.slice(i, i + groupSize)

        data.push(...group)
      }

      //

      const arr = data.map((item: any) => {
        const obj: NObject = {}

        column.map((i) => {
          obj[i.title] = item[i.key]
        })

        return obj
      })

      messageRef?.current?.handleClick(t('Export success'), 'success')

      // 导出XLSX
      const worksheet = XLSX.utils.json_to_sheet(arr)
      const workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      XLSX.writeFile(
        workbook,
        `${props.analysisInfo.name}-${formatDate(new Date())}.xlsx`
      )
    }

    // const handleExportWord = () => {
    //   // 转换为 Word 文档
    //   // 获取编辑器中的 HTML 内容

    //   const htmlContent = containerRef.current.innerHTML
    //   const docx = htmlDocx.asBlob(htmlContent)

    //   saveAs(docx, 'exported-document.docx')
    // }

    const handleClose = () => {
      setOpen(false)
    }

    const judgeAcmg = (value: string) => {
      if (value) {
        const temp = value
          .split(' ')
          .join(',')
          .split('-')
          .join(',')
          .split(',')
          .map((item) => item.toLowerCase().substring(0, 1))
          .join('')

        switch (temp) {
          case 'us':
            return '意义未明的'
          case 'b':
            return '良性的'
          case 'lb':
            return '可能良性的'
          case 'p':
            return '致病的'
          case 'lp':
            return '可能致病的'

          default:
            return temp
        }
      } else {
        return ''
      }
    }

    const extractIdsFromUrls = (text: string) => {
      // 使用正则表达式匹配 URL

      const urlRegex = /\bhttps?:\/\/[^\s/$.?#].[^\s]*\b/g

      const urls = text.match(urlRegex)

      // 提取 URL 中的数字部分（假设数字在 URL 的路径部分）

      const ids = urls
        ? urls
            .map((url) => {
              const idMatch = url.match(/\/(\d+)/)

              return idMatch ? idMatch[1] : null
            })
            .filter((id) => id !== null)
        : []

      return ids
    }

    React.useEffect(() => {
      if (props.current && props.analysisInfo.genomeBuild) {
        fetchReportsByID.mutateAsync(props.current)
      }
    }, [props.current, props.analysisInfo.genomeBuild])

    const fetchReportsByID = useMutation({
      mutationFn: async (data: number) => await getReportsByID(data),
      onSuccess: async (data: Reports) => {
        if (data) {
          data.reportJson =
            data.reportJson && isJson(data.reportJson)
              ? JSON.parse(data.reportJson)
              : ''

          setRepoet(data)

          if (
            data &&
            data.templatePath === '4' &&
            data.metadata &&
            isJson(data.metadata)
          ) {
            const value = JSON.parse(data.metadata)

            //

            setRadioValue(value.value ?? '')

            setSetsValue(value.set.setValue)

            setSetsValue2(value.set.setValue2)

            setSignature(value.signature ?? '')

            setSignature2(value.signature2 ?? '')

            setSignature3(value.signature3 ?? '')
          }

          if (
            data &&
            (data.templatePath === '12' || data.templatePath === '13') &&
            data.metadata &&
            isJson(data.metadata)
          ) {
            const value = JSON.parse(data.metadata)

            //

            setRadioValue(value.value ?? '')

            setRadioValue1(value.value2 ?? '')

            setRadioValue2(value.value3 ?? '')

            setSignature(value.signature ?? '')

            setSignature2(value.signature2 ?? '')

            setSignature3(value.signature3 ?? '')

            setThalassemia(value.thalassemia)
          }

          if (
            data &&
            (data.templatePath === '6' ||
              data.templatePath === '7' ||
              data.templatePath === '22') &&
            data.metadata &&
            isJson(data.metadata) &&
            type === 'sample'
          ) {
            const value = JSON.parse(data.metadata)

            //

            setIsRoh(Boolean(value.isRoh))

            setACMGSF(Boolean(value.isACMGSF))
            if (props.analysisInfo.pipelineVersion) {
              const datas = await getGlsRohList.mutateAsync(
                id as unknown as number
              )

              setRohList(
                datas.regions.map((item: any, index) => {
                  item.index = index
                  item.chrom = item.chromosome
                  const temp = item.chromosome.split('chr')

                  item.chromIndex =
                    temp && temp.length === 2 ? Number(temp[1]) : item.chrom

                  item.begin = Number(item.begin) as unknown as string

                  item.end = Number(item.end) as unknown as string

                  item.size = Number(item.size_mb) as unknown as string

                  item.nbVariants = Number(
                    item.nb_variants
                  ) as unknown as string

                  item.percentageHomozygosity = Number(
                    item.percentage_homozygosity
                  ) as unknown as string

                  return item
                })
              )
            } else {
              const datas = await getRohList.mutateAsync(
                id as unknown as number
              )

              datas.data.shift()

              setRohList(
                datas.data.map((item: any, index) => {
                  item.index = index
                  const temp = item.chrom.split('chr')

                  item.chromIndex =
                    temp && temp.length === 2 ? Number(temp[1]) : item.chrom

                  item.begin = Number(item.begin) as unknown as string

                  item.end = Number(item.end) as unknown as string

                  item.size = Number(item.size) as unknown as string

                  item.nbVariants = Number(item.nbVariants) as unknown as string

                  item.percentageHomozygosity = Number(
                    item.percentageHomozygosity
                  ) as unknown as string

                  return item
                })
              )
            }
          }

          if (
            data &&
            data.templatePath === '21' &&
            data.metadata &&
            isJson(data.metadata) &&
            type === 'sample'
          ) {
            const value = JSON.parse(data.metadata)

            setACMGSF(Boolean(value.isACMGSF))
          }

          if (
            data &&
            (data.templatePath === '24' ||
              data.templatePath === '25' ||
              data.templatePath === '26') &&
            data.metadata &&
            isJson(data.metadata) &&
            type === 'sample'
          ) {
            const value = JSON.parse(data.metadata)

            if (value && value.signature) {
              setSignature(value.signature ?? '')
            }

            if (value && value.signature2) {
              setSignature2(value.signature2 ?? '')
            }

            if (value && value.signature3) {
              setSignature3(value.signature3 ?? '')
            }

            if (value && value.signature4) {
              setSignature4(value.signature4 ?? '')
            }
            setIsRoh(Boolean(value.isRoh))
            if (props.analysisInfo.pipelineVersion) {
              const datas = await getGlsRohList.mutateAsync(
                id as unknown as number
              )

              setRohList(
                datas.regions.map((item: any, index) => {
                  item.index = index
                  item.chrom = item.chromosome
                  const temp = item.chromosome.split('chr')

                  item.chromIndex =
                    temp && temp.length === 2 ? Number(temp[1]) : item.chrom

                  item.begin = Number(item.begin) as unknown as string

                  item.end = Number(item.end) as unknown as string

                  item.size = Number(item.size_mb) as unknown as string

                  item.nbVariants = Number(
                    item.nb_variants
                  ) as unknown as string

                  item.percentageHomozygosity = Number(
                    item.percentage_homozygosity
                  ) as unknown as string

                  return item
                })
              )
            } else {
              const datas = await getRohList.mutateAsync(
                id as unknown as number
              )

              datas.data.shift()

              setRohList(
                datas.data.map((item: any, index) => {
                  item.index = index
                  const temp = item.chrom.split('chr')

                  item.chromIndex =
                    temp && temp.length === 2 ? Number(temp[1]) : item.chrom

                  item.begin = Number(item.begin) as unknown as string

                  item.end = Number(item.end) as unknown as string

                  item.size = Number(item.size) as unknown as string

                  item.nbVariants = Number(item.nbVariants) as unknown as string

                  item.percentageHomozygosity = Number(
                    item.percentageHomozygosity
                  ) as unknown as string

                  return item
                })
              )
            }
          }

          if (
            data &&
            (data.templatePath === '6' ||
              data.templatePath === '7' ||
              data.templatePath === '8' ||
              data.templatePath === '9' ||
              data.templatePath === '21' ||
              data.templatePath === '22') &&
            data.metadata &&
            isJson(data.metadata)
          ) {
            const value = JSON.parse(data.metadata)

            if (value && value.signature) {
              setSignature(value.signature ?? '')
            }

            if (value && value.signature2) {
              setSignature2(value.signature2 ?? '')
            }

            if (value && value.signature3) {
              setSignature3(value.signature3 ?? '')
            }

            if (value && value.sanger) {
              //

              setSanger(value.sanger)
            }
          }

          getVariantReport.mutateAsync({
            objectId: id,
            objectType: type,
            report: data
          } as any)

          getSamplesQcData(type, id as unknown as number)

          // patientSample.mutateAsync(id as any)
        }
      }
    })

    const getUserACMGLogs = useMutation({
      mutationFn: async (data: UserACMGLogs) => await fetchUserACMGLogs(data),
      onSuccess: (data, params, context) => {
        //post返回的结果
        // setTranslates(data)
        if (data && data.list) {
          setUserAcmgData(data.list)
        }
      }
    })

    const fetchScipCnvDescription = useMutation({
      mutationFn: async (data: { id: number; dto: GetCnvScipDescriptionDto }) =>
        await getScipCnvDescription(data)
    })

    const Translate = useMutation({
      mutationFn: async (data: TranslateDto) => await translate(data),
      onSuccess: (data, params, context) => {
        //post返回的结果
      }
    })

    const Translates = useMutation({
      mutationFn: async (data: { params: TranslateBulkDto }) => {
        try {
          return await translates(data.params)
        } catch (error) {
          return null
        }
      }
    })

    const getVariantReport = useMutation({
      mutationFn: (data) =>
        getVariantReports({
          objectId: id,
          objectType: type
        } as any),
      onSuccess: async (data, params: any) => {
        try {
          const report = params.report

          messageRef?.current?.handleClick('获取中，请稍后', 'info')

          if (data.list && data.list.length) {
            if (report && report.metadata && isJson(report.metadata)) {
              const metadata = JSON.parse(report.metadata)
              let list = []
              const newOMIMDataChecked: any[] = []
              const oldOMIMDataChecked: any[] = []

              if (metadata.json) {
                list = unique(
                  metadata.json
                    ?.map((item: string) => {
                      const temp = data.list[0].snvVariants.find(
                        (items: any) => item === getVariantId(items)
                      )

                      if (temp) return temp
                    })
                    .filter((item: any) => item)
                    .map((item: any) => {
                      item.keyId = getVariantId(item)

                      return {
                        ...item
                      }
                    }),
                  'keyId'
                )

                newOMIMDataChecked.push(...metadata.newOMIMData)
                oldOMIMDataChecked.push(...metadata.oldOMIMData)
              } else
                list = unique(
                  metadata
                    .map((item: string) => {
                      const temp = data.list[0].snvVariants.find(
                        (items: any) => item === getVariantId(items)
                      )
                      if (temp) return temp
                    })
                    .filter((item: any) => item)
                    .map((item: any) => {
                      item.keyId = getVariantId(item)

                      return {
                        ...item
                      }
                    }),
                  'keyId'
                )

              const user = JSON.parse(localStorage.getItem('user') || '{}')

              const userParams: UserACMGLogs = {
                type:
                  type === 'sample' ? ObjectType.SAMPLE : ObjectType.ANALYSIS,
                objectId: id as any,
                variantKeys: list.map(
                  (item: any) =>
                    `${item.gene}-${item.c_nomen}-${item.transcript}`
                )
              }

              const dataList = await getUserACMGLogs.mutateAsync(userParams)

              const UserACMGLogs =
                dataList && dataList.list ? dataList.list : []

              //

              // 主要发现详情

              const tempList = await Promise.all(
                list.map(async (row: any) => {
                  row.keyId = getVariantId(row)
                  const OMIMData1 = row.OMIM?.omimData
                    ? row.OMIM?.omimData
                    : row.omim_phenotypes
                    ? row.omim_phenotypes
                    : row.omim_genes
                    ? row.omim_genes
                        .map((item: any) => item.omim_phenotypes)
                        .flat()
                    : row.oldOMIMData
                    ? row.oldOMIMData
                    : []
                  const OMIMData2 = row.OMIM?.geneDiseaseTranslated?.data
                    ? row.OMIM?.geneDiseaseTranslated?.data
                    : row.omim_curate_phenotypes
                    ? row.omim_curate_phenotypes
                    : row.omim_genes
                    ? row.omim_genes
                        .map((item: any) => item.omim_curate_phenotypes)
                        .flat()
                    : row.newOMIMData
                    ? row.newOMIMData
                    : []
                  const oldOMIMData = OMIMData1.map((item: any) => {
                    const inheritances: string[] = []
                    const clinicalSynopsiss = isJson(item.clinical_synopsis)
                      ? JSON.parse(item.clinical_synopsis)
                      : item.clinicalSynopsis

                    if (
                      item &&
                      clinicalSynopsiss &&
                      clinicalSynopsiss.INHERITANCE &&
                      Array.isArray(clinicalSynopsiss.INHERITANCE)
                    ) {
                      clinicalSynopsiss.INHERITANCE.forEach((str: string) =>
                        inheritances.push(str.toLowerCase())
                      )
                      const inheritance = formatVariantInheritance(
                        Array.from([...new Set(inheritances)]).join(',')
                      )

                      item.inheritance =
                        inheritance || inheritance !== ''
                          ? inheritance
                          : Array.from([
                              ...new Set(clinicalSynopsiss.INHERITANCE)
                            ]).join(',')
                    }
                    return item
                  }).filter((item: any) => {
                    const keyid = `${row.keyId}_${row.variantsType}-${
                      item.phenoName ?? item.pheno_name
                    }`
                    const temp = oldOMIMDataChecked.find((i) =>
                      i.includes(keyid)
                    )
                    if (temp && temp.includes('false')) return false
                    else return true
                  })
                  console.log('newOMIMDataChecked', newOMIMDataChecked, row)
                  console.log('oldOMIMDataChecked', oldOMIMDataChecked)

                  const newOMIMData = OMIMData2.filter((item: any) => {
                    const keyid = `${row.keyId}_${row.variantsType}-${item.disease}`
                    const temp = newOMIMDataChecked.find((i) =>
                      i.includes(keyid)
                    )

                    if (temp && temp.includes('false')) return false
                    else return true
                  })
                  const OMIMValue = `${unique(oldOMIMData, 'phenoName')
                    .map(
                      (item: {
                        pheno_name_cn: any
                        phenoName: any
                        pheno_name: any
                      }) => {
                        if (item.pheno_name_cn) return null
                        else return item.phenoName ?? item.pheno_name
                      }
                    )
                    .filter((item) => item)
                    .join(',')}`
                  const newOMIMValue = `${unique(newOMIMData, 'disease')
                    .map((item: { genetic_mode: any; disease: any }) => {
                      return `${item.genetic_mode}--${item.disease}`
                    })
                    .filter((item) => item)
                    .join(',')}`

                  row.newOMIMValue = newOMIMValue

                  const details = row.pos
                    ? await getVariantDetails.mutateAsync({
                        chrom: row.chrom,
                        pos: row.pos,
                        REF: row.REF || row.ref,
                        ALT: row.ALT || row.alt,
                        gene: row.gene,
                        analysisItemType: row.analysisItemType
                      })
                    : null

                  row.Details = details

                  if (details && details.acmg) {
                    const acmgData = await Promise.all(
                      details.acmg.map(async (item: string) => {
                        const sourceLanguage = 'en',
                          targetLanguage = 'zh'
                        const acmgParams: TranslateDto = {
                          sourceLanguage,
                          targetLanguage,
                          sourceText: item ?? '-'
                        }

                        // return await Translate.mutateAsync(acmgParams)
                        return item
                      })
                    )

                    row.acmg_zh = acmgData
                  }

                  // 就管道与新管道数值转换
                  row.SV_start = row.SV_start
                    ? row.SV_start
                    : row.start
                    ? row.start
                    : ''
                  row.SV_end = row.SV_end ? row.SV_end : row.end ? row.end : ''
                  row.SV_type = row.SV_type
                    ? row.SV_type
                    : row.sv_type
                    ? row.sv_type
                    : ''
                  row.AnnotSV_evidences = row.AnnotSV_evidences
                    ? row.AnnotSV_evidences
                    : row.score_details
                    ? row.score_details
                    : ''
                  row.CN = row.CN ? row.CN : row.cn ? row.cn : ''
                  row.LEN = row.LEN
                    ? row.LEN
                    : row.sv_length
                    ? row.sv_length
                    : ''
                  row.transcript = row.transcript
                    ? row.transcript
                    : row.feature
                    ? row.feature
                    : ''
                  row.var_location = row.var_location
                    ? row.var_location
                    : row.variant_locations
                    ? row.variant_locations.join(';')
                    : ''
                  row.coding_effect = row.coding_effect
                    ? row.coding_effect
                    : row.consequence
                    ? row.consequence
                    : ''
                  row.ACMG_classification = row.ACMG_classification
                    ? row.ACMG_classification
                    : row.acmg_classification
                    ? row.acmg_classification
                    : ''
                  row.user_acmg_classification = row.user_acmg_classification
                    ? row.user_acmg_classification
                    : ''
                  row.coverage = row.coverage
                    ? row.coverage
                    : row.ad
                    ? row.ad
                    : ''
                  row.allele_frequency = row.allele_frequency
                    ? row.allele_frequency
                    : row.allele_balance
                    ? row.allele_balance
                    : ''
                  row.c_nomen = row.c_nomen
                    ? row.c_nomen
                    : row.hgvsc
                    ? row.hgvsc
                    : ''
                  row.p_nomen = row.p_nomen
                    ? row.p_nomen
                    : row.hgvsp
                    ? row.hgvsp
                    : ''
                  row.REF = row.REF ? row.REF : row.ref ? row.ref : ''
                  row.ALT = row.ALT ? row.ALT : row.alt ? row.alt : ''
                  if (row.start && row.end) {
                    row.pos = `${row.start}-${row.end}`
                  }
                  row.gnomAD_exome_ALL = row.gnomAD_exome_ALL ?? row.gnomade_af
                  row.gnomAD_exome_EAS =
                    row.gnomAD_exome_EAS ?? row.gnomade_eaf_af
                  row.gnomAD_genome_ALL =
                    row.gnomAD_genome_ALL ?? row.gnomadg_af
                  row.gnomAD_genome_EAS =
                    row.gnomAD_genome_EAS ?? row.gnomadg_eass_af

                  row.OMIMData = await Promise.all(
                    unique(oldOMIMData, 'phenoName')
                      .filter((item) => item)
                      .map(async (items) => {
                        items.phenoClinicalFeaturesCNStr =
                          items.phenoClinicalFeaturesCN?.map((item: any) => {
                            const temp = item
                              .filter((i: any) => i && i.text && i.text !== '.')
                              .map((i: any) => `${i.text}`)
                              .join('')

                            return temp
                          }) ?? []

                        items.phenoClinicalFeaturesENStr =
                          items.phenoClinicalFeatures?.map((item: any) => {
                            const temp = item
                              .filter((i: any) => i && i.text && i.text !== '.')
                              .map((i: any) => `${i.text}`)
                              .join('')

                            return temp
                          }) ?? []

                        items.phenoDescriptionCNStr =
                          items.phenoDescriptionCN?.map((item: any) => {
                            const temp = item
                              .filter((i: any) => i && i.text && i.text !== '.')
                              .map((i: any) => `${i.text}`)
                              .join('')

                            return temp
                          }) ?? []

                        items.phenoDescriptionENStr =
                          items.phenoDescription?.map((item: any) => {
                            const temp = item
                              .filter((i: any) => i && i.text && i.text !== '.')
                              .map((i: any) => `${i.text}`)
                              .join('')

                            return temp
                          }) ?? []

                        return items
                      })
                  )

                  const geneDiseaseTranslated = unique(newOMIMData, 'disease')
                    .filter((item) => item)
                    .map((items) => {
                      return items
                    })

                  const omimData = unique(oldOMIMData, 'pheno_name_cn')
                    .filter((item) => item)
                    .map((items) => {
                      return items
                    })
                    .map((item) => {
                      item.phenoDescriptionENStr =
                        item.phenoDescription?.map((item: any) => {
                          const temp = item
                            .filter((i: any) => i && i.text && i.text !== '.')
                            .map((i: any) => `${i.text}`)
                            .join('')

                          return temp
                        }) ?? []

                      return {
                        genetic_mode: item.inheritance,
                        disease: item.pheno_name_cn,
                        disease_description_cn: item.phenoDescriptionENStr,
                        phenotype: '',
                        omimId: item.phenoMim
                      }
                    })

                  row.newOMIMData = newOMIMData
                    ? geneDiseaseTranslated
                    : omimData

                  row.OMIMCN = `${unique(newOMIMData, 'disease')
                    .map((item: any) => {
                      return `${item.genetic_mode}-${item.disease}`
                    })
                    .filter((item) => item)
                    .join(',')}`

                  row.OMIMEN = `${unique(oldOMIMData, 'phenoName')
                    .map((item: any) => {
                      return `${item.inheritance}-${
                        item.phenoName ?? item.pheno_name
                      }`
                    })
                    .filter((item) => item)
                    .join(',')}`

                  row.OMIMFlat = row.OMIMArr
                    ? row.OMIMArr.map((i: any) => i.omimData)
                        .flat()
                        .map((i: any) => {
                          const inheritances: string[] = []

                          if (
                            i &&
                            i.clinicalSynopsis &&
                            i.clinicalSynopsis.INHERITANCE &&
                            Array.isArray(i.clinicalSynopsis.INHERITANCE)
                          ) {
                            i.clinicalSynopsis.INHERITANCE.forEach(
                              (str: string) =>
                                inheritances.push(str.toLowerCase())
                            )
                            const inheritance = formatVariantInheritance(
                              Array.from([...new Set(inheritances)]).join(',')
                            )

                            const Inheritance =
                              inheritance || inheritance !== ''
                                ? inheritance
                                : Array.from([
                                    ...new Set(i.clinicalSynopsis.INHERITANCE)
                                  ]).join(',')

                            i.inheritance = Inheritance
                          }
                          return {
                            ...i
                          }
                        })
                        .filter(
                          (item: any) =>
                            item.inheritance && item.inheritance !== '.'
                        )
                    : []

                  //

                  if (OMIMValue) {
                    const sourceLanguage = 'en',
                      targetLanguage = 'zh'
                    const OMIMParams: TranslateDto = {
                      sourceLanguage,
                      targetLanguage,
                      sourceText: OMIMValue ?? '-'
                    }

                    const OMIMData = await Translate.mutateAsync(OMIMParams)

                    row.OMIMCN = OMIMData
                  }

                  if (row.MitoMap) {
                    row.OMIMCN = row.MitoMap.disease_ch
                  }

                  if (!row.omim_info) {
                    row.omim_info = []
                  }

                  const rs_id = row.rs_id || row.rsId

                  // if (
                  //   report &&
                  //   (report.templatePath === '7' ||
                  //     report.templatePath === '6' ||
                  //     report.templatePath === '22') &&
                  //   (row.variantsType === 'KeyFinding' ||
                  //     row.variantsType === 'IncidentalDiscovery')
                  // ) {
                  //   if (rs_id && rs_id !== '.') {
                  //     const data = await getLitVarArticle.mutateAsync(rs_id)

                  //     row.LitVarArticle = data
                  //   }
                  // }

                  // 筛选基因文献

                  // if (
                  //   report &&
                  //   (report.templatePath === '1' ||
                  //     report.templatePath === '2' ||
                  //     report.templatePath === '9')
                  // ) {
                  //   const params = {
                  //     gene: row.gene,
                  //     rsId: rs_id,
                  //     pnomen: row.p_nomen ?? row.hgvsp,
                  //     cnomen: row.c_nomen ?? row.hgvsc,
                  //     pubmed: `${row.pubmed}`,
                  //     omimPubmed: row.OMIM?.pubmedIds
                  //       ? row.OMIM?.pubmedIds
                  //       : row.MitoMap?.pubmed_ids
                  //   }

                  //   if (params.omimPubmed && params.rsId) {
                  //     const articles = await Articles.mutateAsync(params)

                  //     const variantPubmedArticles =
                  //       articles.variantPubmedArticles.map((i: any) => {
                  //         return {
                  //           ...i,
                  //           keyId: row.keyId
                  //         }
                  //       })
                  //     const genePubmedArticles =
                  //       articles.genePubmedArticles.map((i: any) => {
                  //         return {
                  //           ...i,
                  //           keyId: row.keyId
                  //         }
                  //       })

                  //     row.genePubmedArticles = genePubmedArticles
                  //       .filter(
                  //         (item: any) =>
                  //           item &&
                  //           item.abstract &&
                  //           item.excerpt &&
                  //           item.year &&
                  //           item.title
                  //       )
                  //       .slice(0, 10)

                  //     row.variantPubmedArticles = variantPubmedArticles
                  //       .filter(
                  //         (item: any) =>
                  //           item &&
                  //           item.abstract &&
                  //           item.excerpt &&
                  //           item.year &&
                  //           item.title
                  //       )
                  //       .slice(0, 10)
                  //   }
                  // }

                  if (
                    (report &&
                      (report.templatePath === '9' ||
                        report.templatePath === '21' ||
                        report.templatePath === '22' ||
                        report.templatePath === '6' ||
                        report.templatePath === '7' ||
                        report.templatePath === '11' ||
                        report?.templatePath === '13') &&
                      report.objectType === ObjectType.SAMPLE &&
                      row.SV_start) ??
                    (row.start && row.SV_end) ??
                    (row.end && row.SV_type) ??
                    (row.sv_type && !row.left_genes)
                  ) {
                    const data = await fetchScipCnvDescription.mutateAsync({
                      id: report.objectId,
                      dto: {
                        chrom: `${row.chrom}` as any,
                        start: row.SV_start ?? row.start,
                        end: row.SV_end ?? row.end,
                        cnvType: row.SV_type ?? row.sv_type
                      }
                    })

                    row.ScipCnvDescription = data
                  }

                  // 筛选clinvar ai文献
                  if (
                    // report.templatePath === '8' ||
                    // report.templatePath === '9' ||
                    // report.templatePath === '11' ||
                    // report.templatePath === '21' ||
                    // report?.templatePath === '13'
                    report.templatePath
                  ) {
                    // if (
                    //   row.chrom &&
                    //   row.pos &&
                    //   (row.REF || row.ref) &&
                    //   (row.ALT || row.alt) &&
                    //   props.analysisInfo.genomeBuild
                    // ) {
                    //   if (
                    //     row.chrom &&
                    //     row.pos &&
                    //     (row.REF || row.ref) &&
                    //     (row.ALT || row.alt) &&
                    //     row.chr_pos_ref_alt_assembly
                    //   ) {
                    //     const variantsParams = {
                    //       assembly:
                    //         parseGenomicString(row.chr_pos_ref_alt_assembly)
                    //           .assembly ?? 'hg19',
                    //       variant: `${row.chrom}-${row.pos}-${
                    //         row.REF || row.ref
                    //       }-${row.ALT || row.alt}`,
                    //       gene_name: row.gene
                    //     }
                    //     const datas = await getVarArticle.mutateAsync(
                    //       variantsParams
                    //     )

                    //     if (datas && datas.details && datas.details[0]) {
                    //       row.VariantsArticles = {
                    //         ...datas.details[0],

                    //         keyId: row.keyId
                    //       }

                    //       // 获取cite
                    //       if (report.templatePath === '21') {
                    //         const articles = (row.VariantsArticles
                    //           .pubmed_articles.literatures ?? []) as any[]
                    //         row.variantPubmedArticles = (
                    //           await Promise.all(
                    //             articles.slice(0, 10).map(async (i: any) => {
                    //               const params = {
                    //                 gene: row.gene,
                    //                 rsId: rs_id,
                    //                 pnomen: row.p_nomen ?? row.hgvsp,
                    //                 cnomen: row.c_nomen ?? row.hgvsc,
                    //                 pubmed: `${i.pmid}`,
                    //                 omimPubmed: row.OMIM?.pubmedIds
                    //                   ? row.OMIM?.pubmedIds
                    //                   : row.MitoMap?.pubmed_ids
                    //               }

                    //               if (params.omimPubmed && params.rsId) {
                    //                 const articles = await Articles.mutateAsync(
                    //                   params
                    //                 )

                    //                 return articles.variantPubmedArticles
                    //                   .map((i: any) => {
                    //                     return {
                    //                       ...i,
                    //                       keyId: row.keyId
                    //                     }
                    //                   })
                    //                   .filter(
                    //                     (item: any) =>
                    //                       item &&
                    //                       item.abstract &&
                    //                       item.excerpt &&
                    //                       item.year &&
                    //                       item.title
                    //                   )
                    //                   .slice(0, 10)
                    //               }
                    //               return []
                    //             })
                    //           )
                    //         )
                    //           .flat()
                    //           .slice(0, 10)
                    //       }
                    //     }
                    //   }
                    // }
                    if (row.clinvar_id) {
                      const datas = await CitationsArticle.mutateAsync(
                        row.clinvar_id
                      )

                      if (datas && Array.isArray(datas) && datas.length > 0) {
                        row.VariantsArticles = datas
                          .map((item, index) => ({
                            ...item,
                            cite: `${
                              item.authors &&
                              Array.isArray(item.authors) &&
                              item.authors
                                .slice(0, 2)
                                .map((i: any) => i.name)
                                .join(',')
                            }，et al(${item.pub_date})${item.title}[PMID:${
                              item.pmid
                            }]`,
                            cite_shengxiang: `${
                              item.authors &&
                              Array.isArray(item.authors) &&
                              item.authors
                                .slice(0, 3)
                                .map((i: any) => i.name)
                                .join(',')
                            },et al.${item.title}.${item.pub_date}`,

                            keyId: row.keyId
                          }))
                          .slice(0, 10)
                      }
                    }
                    if (
                      row.CLINVAR_variant_id &&
                      row.CLINVAR_variant_id !== '.'
                    ) {
                      const datas = await CitationsArticle.mutateAsync(
                        row.CLINVAR_variant_id
                      )

                      if (datas && Array.isArray(datas) && datas.length > 0) {
                        row.VariantsArticles = datas
                          .map((item, index) => ({
                            ...item,
                            cite: `${
                              item.authors &&
                              Array.isArray(item.authors) &&
                              item.authors
                                .slice(0, 2)
                                .map((i: any) => i.name)
                                .join(',')
                            }，et al(${item.pub_date})${item.title}[PMID:${
                              item.pmid
                            }]`,

                            keyId: row.keyId
                          }))
                          .slice(0, 10)
                      }
                    }
                  }

                  if (row.chrom === 'MT') {
                    const mitoMapParams: GetMitoMapDataDto[] = [
                      {
                        pos: row.pos,
                        REF: row.REF || row.ref,
                        ALT: row.ALT || row.alt
                      }
                    ]

                    const data = await getMitomap.mutateAsync({
                      mitoMapParams
                    })

                    row.MitoMap = data && data.length ? data[0] : null
                  }

                  return row
                })
              )
              console.log('tempList', tempList)

              //

              setReportsVariants(tempList)
            }
          }
        } catch (error) {
          //
          console.log(error)

          messageRef?.current?.handleClick('获取失败，请稍后重试', 'error')
        }
      }
    })

    const fetchCnvChromPlot = useMutation({
      mutationFn: async (id: string) => {
        return await getCnvChromPlot(id)
      }
    })

    const getVariantDetails = useMutation({
      mutationFn: async (data: any) => {
        try {
          const variants = {
            chrom: data.chrom,
            pos: data.pos,
            REF: data.REF || data.ref,
            ALT: data.ALT || data.alt,
            gene: data.gene,
            genomeBuild: props.analysisInfo.genomeBuild
          }

          // //

          if (type === 'sample')
            return await fetchVariantDetails({
              sampleId: id as unknown as number,
              variants
            })
          else {
            const analysisItemType =
              data.analysisItemType ?? localStorage.getItem('analysisItemType')

            return await fetchAnalysisVariantDetails({
              analysisId: id as unknown as number,
              variants: {
                ...variants,
                analysisItemType
              }
            })
          }
        } catch (error) {
          return null
        }
      },
      onSuccess: async (variantDetails) => {
        if (variantDetails) {
          const sourceLanguage = 'en',
            targetLanguage = 'zh'

          const params: TranslateDto = {
            sourceLanguage,
            targetLanguage,
            sourceText: variantDetails.acmg.join(',')
          }
          if (params.sourceText) {
            // const data = await Translate.mutateAsync(params)
            // variantDetails.acmgCN = data
          } else variantDetails.acmgCN = ''
        }

        // setVariantDetails(variantDetails)
      },
      onError: (error) => {
        //
      }
    })

    const getMitomap = useMutation({
      mutationFn: async (data: { mitoMapParams: GetMitoMapDataDto[] }) =>
        await fetchMitomap(data.mitoMapParams),
      onSuccess: (datas: IMitoMapSearchSource[], params) => {
        //post返回的结果
      }
    })

    const fetchGlsQc = useMutation({
      mutationFn: async (data: { id: any }) =>
        await getGlsQc({
          id: data.id,
          platform: 'parabricks'
        }),
      onSuccess: (data: GlsQc) => {
        //post返回的结果
      }
    })

    const getHomRegions = useMutation({
      mutationFn: async (id: string) => await getQCData(id),
      onSuccess: async (data: ISamplesQcData) => {
        //post返回的结果
      }
    })

    const patientSample = useMutation({
      mutationFn: async (id: number) => await fetchPatientBySampleId(id),

      onSuccess: async (data) => {
        if (data && data.list && data.list.length) {
          const patient = data.list[0].patients
          const sample = data.list[0].sample

          setReportValue({
            ...reportValue,
            patient,
            sample
          })

          let fastQc = null

          try {
            if (sample.pipelineVersion) {
              const datas = await fetchGlsQc.mutateAsync({
                id: sample.id as any
              })
              const barChartData =
                sample.vcfType === 'wgs'
                  ? [
                      { name: '1x', value: datas.pct_wgs_1x * 100 },
                      { name: '10x', value: datas.pct_wgs_10x * 100 },
                      { name: '20x', value: datas.pct_wgs_20x * 100 },
                      { name: '30x', value: datas.pct_wgs_30x * 100 },
                      { name: '40x', value: datas.pct_wgs_40x * 100 },
                      { name: '50x', value: datas.pct_wgs_50x * 100 }
                    ]
                  : [
                      { name: '1x', value: datas.pct_target_1x * 100 },
                      { name: '2x', value: datas.pct_target_2x * 100 },
                      { name: '10x', value: datas.pct_target_10x * 100 },
                      { name: '20x', value: datas.pct_target_20x * 100 },
                      { name: '30x', value: datas.pct_target_30x * 100 }
                    ]
              fastQc = {
                metricsData: {
                  rawReads: datas.total_bases,
                  readsMappedPercent: datas?.mapping_rate
                    ? `${Number((datas?.mapping_rate * 100).toFixed(2))}%`
                    : '',
                  seqtk_q30: datas?.fastq_qc,
                  meanCoverage: `${Number(datas?.mean_target_coverage).toFixed(
                    2
                  )}X`
                },
                barChartData
              }
            } else {
              const datas = await getHomRegions.mutateAsync(
                id as unknown as string
              )

              if (datas && datas.fastqc) {
                fastQc = datas.fastqc
              }
            }
          } catch (error) {
            //
          }

          if (
            report &&
            (!report.reportJson || !Array.isArray(report.reportJson))
          ) {
            const cnvPlotData = await fetchCnvChromPlot.mutateAsync(
              sample.id as any
            )

            if (cnvPlotData && cnvPlotData.plotAllData) {
              setSamples([
                {
                  ...reportValue,
                  patient,
                  sample,
                  plotAllData: cnvPlotData.plotAllData,
                  fastQc
                }
              ])
            } else
              setSamples([
                {
                  ...reportValue,
                  patient,
                  sample,
                  fastQc
                }
              ])
          } else {
            setSamples([
              {
                ...reportValue,
                patient,
                sample,
                fastQc
              }
            ])
          }
        }
      }
    })

    const analyzeInfoByAnalysis = useMutation({
      mutationFn: async (id: string) => await fetchAnalyzeInfoByAnalysisId(id),

      onSuccess: async (data: any) => {
        // 家系
        if (data && data.affectedChild && data.list && data.list.length) {
          const sample = data.affectedChild
          setReportValue({
            ...reportValue,
            patient: sample.patients ? sample.patients[0] : {},
            sample
          })

          const samples = data.list[0].analysisSamples

          const sampleData = await Promise.all(
            samples.map(async (item: any) => {
              let fastQc = null

              try {
                if (sample.pipelineVersion) {
                  const datas = await fetchGlsQc.mutateAsync({
                    id: sample.id as any
                  })
                  const barChartData =
                    sample.vcfType === 'wgs'
                      ? [
                          { name: '1x', value: datas.pct_wgs_1x },
                          { name: '10x', value: datas.pct_wgs_10x },
                          { name: '20x', value: datas.pct_wgs_20x },
                          { name: '30x', value: datas.pct_wgs_30x },
                          { name: '40x', value: datas.pct_wgs_40x },
                          { name: '50x', value: datas.pct_wgs_50x }
                        ]
                      : [
                          { name: '1x', value: datas.pct_target_1x },
                          { name: '2x', value: datas.pct_target_2x },
                          { name: '10x', value: datas.pct_target_10x },
                          { name: '20x', value: datas.pct_target_20x },
                          { name: '30x', value: datas.pct_target_30x }
                        ]
                  fastQc = {
                    metricsData: {
                      rawReads: datas.total_bases,
                      readsMappedPercent: datas?.mapping_rate
                        ? `${Number((datas?.mapping_rate * 100).toFixed(2))}%`
                        : '',
                      seqtk_q30: datas?.fastq_qc,
                      meanCoverage: `${Number(
                        datas?.mean_target_coverage
                      ).toFixed(2)}X`
                    },
                    barChartData
                  }
                } else {
                  const datas = await getHomRegions.mutateAsync(
                    id as unknown as string
                  )

                  if (datas && datas.fastqc) {
                    fastQc = datas.fastqc
                  }
                }
              } catch (error) {
                //
              }
              if (
                report &&
                (!report.reportJson || !Array.isArray(report.reportJson))
              ) {
                const cnvPlotData = await fetchCnvChromPlot.mutateAsync(
                  item.id as any
                )
                if (cnvPlotData && cnvPlotData.plotAllData) {
                  return {
                    ...reportValue,
                    sample: item,
                    patient: item.patients ? item.patients[0] : {},
                    plotAllData: cnvPlotData.plotAllData,
                    fastQc
                  }
                } else
                  return {
                    ...reportValue,
                    sample: item,
                    patient: item.patients ? item.patients[0] : {},
                    fastQc
                  }
              } else
                return {
                  ...reportValue,
                  sample: item,
                  patient: item.patients ? item.patients[0] : {},
                  fastQc
                }
            })
          )

          setSamples(sampleData)

          //
        } else if (
          data &&
          data.list &&
          data.list.length &&
          !data.affectedChild
        ) {
          const samples = data.list[0].analysisSamples
          const sample = samples[0]
          setReportValue({
            ...reportValue,
            patient: sample.patients ? sample.patients[0] : {},
            sample
          })
          const sampleData = await Promise.all(
            samples.map(async (item: any) => {
              let fastQc = null

              try {
                if (sample.pipelineVersion) {
                  const datas = await fetchGlsQc.mutateAsync({
                    id: sample.id as any
                  })
                  const barChartData =
                    sample.vcfType === 'wgs'
                      ? [
                          { name: '1x', value: datas.pct_wgs_1x },
                          { name: '10x', value: datas.pct_wgs_10x },
                          { name: '20x', value: datas.pct_wgs_20x },
                          { name: '30x', value: datas.pct_wgs_30x },
                          { name: '40x', value: datas.pct_wgs_40x },
                          { name: '50x', value: datas.pct_wgs_50x }
                        ]
                      : [
                          { name: '1x', value: datas.pct_target_1x },
                          { name: '2x', value: datas.pct_target_2x },
                          { name: '10x', value: datas.pct_target_10x },
                          { name: '20x', value: datas.pct_target_20x },
                          { name: '30x', value: datas.pct_target_30x }
                        ]
                  fastQc = {
                    metricsData: {
                      rawReads: datas.total_bases,
                      readsMappedPercent: datas?.mapping_rate
                        ? `${Number((datas?.mapping_rate * 100).toFixed(2))}%`
                        : '',
                      seqtk_q30: datas?.fastq_qc,
                      meanCoverage: `${Number(
                        datas?.mean_target_coverage
                      ).toFixed(2)}X`
                    },
                    barChartData
                  }
                } else {
                  const datas = await getHomRegions.mutateAsync(
                    id as unknown as string
                  )

                  if (datas && datas.fastqc) {
                    fastQc = datas.fastqc
                  }
                }
              } catch (error) {
                //
              }
              if (
                report &&
                (!report.reportJson || !Array.isArray(report.reportJson))
              ) {
                const cnvPlotData = await fetchCnvChromPlot.mutateAsync(
                  item.id as any
                )
                if (cnvPlotData && cnvPlotData.plotAllData) {
                  return {
                    ...reportValue,
                    sample: item,
                    patient: item.patients ? item.patients[0] : {},
                    plotAllData: cnvPlotData.plotAllData,
                    fastQc
                  }
                } else
                  return {
                    ...reportValue,
                    sample: item,
                    patient: item.patients ? item.patients[0] : {},
                    fastQc
                  }
              } else
                return {
                  ...reportValue,
                  sample: item,
                  patient: item.patients ? item.patients[0] : {},
                  fastQc
                }
            })
          )

          setSamples(sampleData)

          //
        }
      }
    })

    //

    const getSamplesQcData = async (type: string, id: number) => {
      if (type === 'sample') {
        return patientSample.mutateAsync(id)
      } else {
        return analyzeInfoByAnalysis.mutateAsync(id as unknown as string)
      }
    }

    const currentRohList = React.useMemo(() => {
      const list = rohList
        .filter(
          (item) =>
            item &&
            item.size &&
            Number(item.size) > rohFilterValue.size &&
            item.nbVariants &&
            Number(item.nbVariants) > rohFilterValue.nbVariants &&
            item.percentageHomozygosity &&
            Number(item.percentageHomozygosity) >
              rohFilterValue.percentageHomozygosity
        )
        .map((items, index) => {
          const Size = Number(items.size)

          const temp = chromSizes.find((item) => item.chrom === items.chrom)
          let isUPD = false

          if (temp) {
            isUPD = Size / (temp.size / 1000000) > 0.05
          }

          return {
            ...items,
            Size,
            isUPD,
            index,
            id: `${items.chrom}_${items.begin}_${items.end}`
          }
        })
        .filter((item) => item.isUPD)

      //

      return list
    }, [rohFilterValue, rohList])

    const getVarArticle = useMutation({
      mutationFn: async (params: GetVariantLiteratureDto) =>
        await getVarDetail(params),
      onSuccess: (datas: any, params) => {
        //post返回的结果
      }
    })
    const CitationsArticle = useMutation({
      mutationFn: async (pubmedId: string) =>
        await getCitationsByVariation({
          id: pubmedId
        }),
      onSuccess: (datas: any[]) => {
        //post返回的结果
      }
    })

    const Articles = useMutation({
      mutationFn: async (data: GetArticlesDto) => await getArticles(data),
      onSuccess: (datas: any) => {
        //post返回的结果
        // setArticles([...articles, ...datas.articles])
      }
    })

    const getRohList = useMutation({
      mutationFn: async (id: number) => await fetchRohList(id),
      onSuccess: (data: IVariantRohList) => {
        //post返回的结果
      }
    })

    const getGlsRohList = useMutation({
      mutationFn: async (id: number) =>
        await getGlsRoh({ id: id as unknown as string }),
      onSuccess: (data: { regions: any[] }) => {
        //post返回的结果
      }
    })

    const getLitVarArticle = useMutation({
      mutationFn: async (rsId: string) => await getLitVarArticles(rsId, 1),
      onSuccess: (datas: any) => {
        //post返回的结果
      }
    })

    const updateReportsMutation = useMutation(editReports, {
      onSuccess: () => {
        fetchReportsByID.mutateAsync(props.current)

        messageRef?.current?.handleClick(t('Saved successfully'), 'success')
      }
    })

    const queryMTVariants = useMutation({
      mutationFn: async (id: number) => {
        if (type === 'sample') {
          if (props.analysisInfo.pipelineVersion) {
            const query = {
              variants: {
                offset: 0,
                limit: 600,
                filter: changeV1Filter({
                  snvOperator: 'gte',
                  snvValue: 0.02
                }),
                id,
                source: 'samples'
              },
              parquetType: 'mt'
            }

            return await getGlsVariants(query)
          } else {
            const query = {
              pageNum: 1,
              pageSize: 600,
              filter: {
                mtOnly: 1,
                snvOperator: 'gte',
                snvValue: 0.02
              },
              sort: {
                classification: 1
              }
            }

            return await getSamplesSvn(query, id)
          }
        } else {
          const query = {
            pageNum: 1,
            pageSize: 600,
            filter: {
              snvOperator: 'gte',
              snvValue: 0.02
            },
            sort: {
              classification: 1
            },
            analysisItemType:
              props.analysisInfo.analysisType === 'carrier'
                ? 'carrier_mt'
                : props.analysisInfo.analysisType === 'big_family'
                ? 'big_family_mt'
                : props.analysisInfo.analysisType === 'case_control'
                ? ''
                : 'family_mt'
          }

          if (query.analysisItemType === '') {
            return {}
          }

          return await getAnalysisVariants(query, id)
        }
      },
      onSuccess: (data: any) => {
        //post返回的结果
        if (props.analysisInfo.pipelineVersion) {
          if (data && data.items) {
            const variants = unique(
              data.items.map((i: any) => {
                i.id = i.variant_id

                i.keyID = `${i.chrom}_${i.pos}`

                return i
              }) ?? '',
              'keyID'
            )

            setDetectionMTVariationList(variants.sort((a, b) => a.pos - b.pos))
          }
          return
        }

        if (data && data.data && data.data.list) {
          const variants = unique(
            data.data.list.map((i: any) => {
              i.id = i._id

              i.keyID = `${i.chrom}_${i.pos}`

              return i
            }) ?? '',
            'keyID'
          )

          setDetectionMTVariationList(variants.sort((a, b) => a.pos - b.pos))
        }
      }
    })

    const getOMIM = useMutation({
      mutationFn: async (data: { geneNames: string[] }) =>
        await fetchOMIM({ geneNames: data.geneNames }),
      onSuccess: async (datas: VariantDetailOmimData[], params) => {
        //post返回的结果
      }
    })

    const queryRawDataVariants = useMutation({
      mutationFn: async (id: number) => {
        if (type === 'sample') {
          if (props.analysisInfo.pipelineVersion) {
            const query = {
              variants: {
                offset: 0,
                limit: 100,
                filter: changeV1Filter({
                  geneNameIn: ACMG3_1And3_2Panel,
                  qualMin: 200,
                  indelOperator: 'gte',
                  indelValue: 0.3,
                  snvOperator: 'gte',
                  snvValue: 0.3,
                  CLINVAR_clnsig_final: ['PAT', 'LP'],
                  classification: ['pathogenic', 'likely pathogenic']
                }),
                id,
                source: 'samples'
              },
              parquetType: 'small'
            }

            return await getGlsVariants(query)
          } else {
            const query = {
              pageNum: 1,
              pageSize: 100,
              filter: {
                geneNameIn: ACMG3_1And3_2Panel,
                qualMin: 200,
                indelOperator: 'gte',
                indelValue: 0.3,
                snvOperator: 'gte',
                snvValue: 0.3,
                CLINVAR_clnsig_final: ['PAT', 'LP'],
                classification: ['pathogenic', 'likely pathogenic']
              },
              sort: {}
            }

            return await getSamplesSvn(query, id)
          }
        } else {
          const query = {
            pageNum: 1,
            pageSize: 100,
            sort: {
              gene: 1,
              gene_min_clinsig: 1
            },
            filter: {
              geneNameIn: ACMG3_1And3_2Panel,
              qualMin: 200,
              indelOperator: 'gte',
              indelValue: 0.3,
              snvOperator: 'gte',
              snvValue: 0.3,
              CLINVAR_clnsig_final: ['PAT', 'LP'],
              classification: ['pathogenic', 'likely pathogenic']
            },
            analysisItemType:
              props.analysisInfo.analysisType === 'carrier'
                ? 'carrier_all_sites'
                : props.analysisInfo.analysisType === 'big_family'
                ? 'big_family'
                : props.analysisInfo.analysisType === 'case_control'
                ? 'total'
                : 'family_raw_data'
          }

          return await getAnalysisVariants(query, id)
        }
      },
      onSuccess: async (data: any) => {
        //post返回的结果

        const variant =
          data && data.data && data.data.list
            ? data.data.list
            : data.items
            ? data.items
            : []

        if (variant.length) {
          let variants = unique(
            variant.map((i: any) => {
              i.id = i._id ?? i.variant_id

              i.keyID = `${i.chrom}_${i.pos}`

              return i
            }) ?? '',
            'keyID'
          )

          const geneNames = variants.map((i) => i.gene).filter((i) => i)

          //

          if (geneNames.length) {
            const OMIMs = await getOMIM.mutateAsync({
              geneNames
            })

            variants = await Promise.all(
              variants.map(async (items) => {
                const temp = OMIMs.find(
                  (item) =>
                    item.geneName === items.gene ||
                    (items.omim_info &&
                      items.omim_info.some((i: string) => i === item.geneName))
                )
                if (temp) {
                  items.OMIM = temp
                  items.OMIMData = unique(temp?.omimData ?? [], 'phenoName')
                    .filter((item) => item)
                    .map((items) => {
                      const inheritances: string[] = []

                      if (
                        items &&
                        items.clinicalSynopsis &&
                        items.clinicalSynopsis.INHERITANCE &&
                        Array.isArray(items.clinicalSynopsis.INHERITANCE)
                      ) {
                        items.clinicalSynopsis.INHERITANCE.forEach(
                          (str: string) => inheritances.push(str.toLowerCase())
                        )

                        const obj = _.cloneDeep(items.clinicalSynopsis)

                        delete obj.INHERITANCE

                        delete obj['MISCELLANEOUS']

                        delete obj['MOLECULAR BASIS']
                        const clinicalSynopsis = flatten3DArray(obj)

                        const sourceText = {} as any

                        clinicalSynopsis.map((item, index) => {
                          sourceText[index] = item
                        })

                        items.clinicalSynopsis_en = Object.getOwnPropertyNames(
                          sourceText
                        ).map((key) => sourceText[key])
                        const inheritance = formatVariantInheritance(
                          Array.from([...new Set(inheritances)]).join(',')
                        )

                        items.inheritance =
                          inheritance || inheritance !== ''
                            ? inheritance
                            : Array.from([
                                ...new Set(items.clinicalSynopsis.INHERITANCE)
                              ]).join(',')
                      }

                      items.phenoClinicalFeaturesCNStr =
                        items.phenoClinicalFeaturesCN?.map((item: any) => {
                          const temp = item
                            .filter((i: any) => i && i.text && i.text !== '.')
                            .map((i: any) => `${i.text}`)
                            .join('')

                          return temp
                        }) ?? []

                      items.phenoClinicalFeaturesENStr =
                        items.phenoClinicalFeatures?.map((item: any) => {
                          const temp = item
                            .filter((i: any) => i && i.text && i.text !== '.')
                            .map((i: any) => `${i.text}`)
                            .join('')

                          return temp
                        }) ?? []

                      items.phenoDescriptionCNStr =
                        items.phenoDescriptionCN?.map((item: any) => {
                          const temp = item
                            .filter((i: any) => i && i.text && i.text !== '.')
                            .map((i: any) => `${i.text}`)
                            .join('')

                          return temp
                        }) ?? []

                      items.phenoDescriptionENStr =
                        items.phenoDescription?.map((item: any) => {
                          const temp = item
                            .filter((i: any) => i && i.text && i.text !== '.')
                            .map((i: any) => `${i.text}`)
                            .join('')

                          return temp
                        }) ?? []

                      return items
                    })

                  const geneDiseaseTranslated = unique(
                    items.OMIM?.geneDiseaseTranslated?.data ?? [],
                    'disease'
                  )
                    .filter((item) => item)
                    .map((items) => {
                      return items
                    })

                  const omimData = unique(
                    items.OMIM?.omimData ?? [],
                    'pheno_name_cn'
                  )
                    .filter((item) => item)
                    .map((items) => {
                      return items
                    })
                    .map((item) => {
                      const inheritances: string[] = []

                      if (
                        item &&
                        item.clinicalSynopsis &&
                        item.clinicalSynopsis.INHERITANCE &&
                        Array.isArray(item.clinicalSynopsis.INHERITANCE)
                      ) {
                        item.clinicalSynopsis.INHERITANCE.forEach(
                          (str: string) => inheritances.push(str.toLowerCase())
                        )
                        const inheritance = formatVariantInheritance(
                          Array.from([...new Set(inheritances)]).join(',')
                        )

                        item.inheritance =
                          inheritance || inheritance !== ''
                            ? inheritance
                            : Array.from([
                                ...new Set(item.clinicalSynopsis.INHERITANCE)
                              ]).join(',')
                      }

                      item.phenoDescriptionENStr =
                        item.phenoDescription?.map((item: any) => {
                          const temp = item
                            .filter((i: any) => i && i.text && i.text !== '.')
                            .map((i: any) => `${i.text}`)
                            .join('')

                          return temp
                        }) ?? []

                      return {
                        genetic_mode: item.inheritance,
                        disease: item.pheno_name_cn,
                        disease_description_cn: item.phenoDescriptionENStr,
                        phenotype: '',
                        omimId: item.phenoMim
                      }
                    })

                  items.newOMIMData = items.OMIM?.geneDiseaseTranslated
                    ? geneDiseaseTranslated
                    : omimData
                }
                items.keyId = getVariantId(items)

                // 就管道与新管道数值转换
                items.transcript = items.transcript
                  ? items.transcript
                  : items.feature
                  ? items.feature
                  : ''
                items.var_location = items.var_location
                  ? items.var_location
                  : items.variant_locations
                  ? items.variant_locations.join(';')
                  : ''
                items.coding_effect = items.coding_effect
                  ? items.coding_effect
                  : items.consequence
                  ? items.consequence
                  : ''
                items.ACMG_classification = items.ACMG_classification
                  ? items.ACMG_classification
                  : items.acmg_classification
                  ? items.acmg_classification
                  : ''
                items.coverage = items.coverage
                  ? items.coverage
                  : items.ad
                  ? items.ad
                  : ''
                items.allele_frequency = items.allele_frequency
                  ? items.allele_frequency
                  : items.allele_balance
                  ? items.allele_balance
                  : ''
                items.c_nomen = items.c_nomen
                  ? items.c_nomen
                  : items.hgvsc
                  ? items.hgvsc
                  : ''
                items.p_nomen = items.p_nomen
                  ? items.p_nomen
                  : items.hgvsp
                  ? items.hgvsp
                  : ''
                items.REF = items.REF ? items.REF : items.ref ? items.ref : ''
                items.ALT = items.ALT ? items.ALT : items.alt ? items.alt : ''
                if (items.start && items.end) {
                  items.pos = `${items.start}-${items.end}`
                }
                items.gnomAD_exome_ALL =
                  items.gnomAD_exome_ALL ?? items.gnomade_af
                items.gnomAD_exome_EAS =
                  items.gnomAD_exome_EAS ?? items.gnomade_eaf_af
                items.gnomAD_genome_ALL =
                  items.gnomAD_genome_ALL ?? items.gnomadg_af
                items.gnomAD_genome_EAS =
                  items.gnomAD_genome_EAS ?? items.gnomadg_eass_af

                // if (
                //   items.chrom &&
                //   items.pos &&
                //   (items.REF || items.ref) &&
                //   (items.ALT || items.alt) &&
                //   items.chr_pos_ref_alt_assembly
                // ) {
                //   const variantsParams = {
                //     assembly:
                //       parseGenomicString(items.chr_pos_ref_alt_assembly)
                //         .assembly ?? 'hg19',
                //     variant: `${items.chrom}-${items.pos}-${
                //       items.REF || items.ref
                //     }-${items.ALT || items.alt}`,
                //     gene_name: items.gene
                //   }
                //   const datas = await getVarArticle.mutateAsync(variantsParams)

                //   if (datas && datas.details && datas.details[0]) {
                //     items.VariantsArticles = {
                //       ...datas.details[0],

                //       keyId: items.keyId
                //     }
                //   }
                // }
                if (items.clinvar_id) {
                  const datas = await CitationsArticle.mutateAsync(
                    items.clinvar_id
                  )

                  if (datas && Array.isArray(datas) && datas.length > 0) {
                    items.VariantsArticles = datas.map((item) => ({
                      ...item,

                      keyId: items.keyId
                    }))
                  }
                }
                if (
                  items.CLINVAR_variant_id &&
                  items.CLINVAR_variant_id !== '.'
                ) {
                  const datas = await CitationsArticle.mutateAsync(
                    `${items.CLINVAR_variant_id}`
                  )

                  if (datas && Array.isArray(datas) && datas.length > 0) {
                    items.VariantsArticles = datas
                      .map((item, index) => ({
                        ...item,
                        Request: `${
                          item.authors &&
                          Array.isArray(item.authors) &&
                          item.authors
                            .slice(0, 2)
                            .map((i: any) => i.name)
                            .join(',')
                        }，et al(${item.pub_date})${item.title}[PMID:${
                          item.pmid
                        }]`,
                        keyId: items.keyId
                      }))
                      .slice(0, 10)
                  }
                }

                // if (
                //   items.clinvar_ids &&
                //   items.clinvar_ids !== '.' &&
                //   Array.isArray(items.clinvar_ids)
                // ) {
                //   const datas = (
                //     await Promise.all(
                //       items.clinvar_ids.map(
                //         async (item: string) =>
                //           await CitationsArticle.mutateAsync(item)
                //       )
                //     )
                //   ).flat()

                //   if (datas && Array.isArray(datas) && datas.length > 0) {
                //     items.VariantsArticles = datas.map((item) => ({
                //       ...item,

                //       keyId: items.keyId
                //     }))
                //   }
                // }

                return items
              })
            )
          }

          const otherVariants = reportsVariants
            .filter(
              (item) =>
                item.variantsType === 'CarrierScreening' ||
                item.variantsType === 'ACMGDiscovery' ||
                item.variantsType === 'OtherDiscovery'
            )
            .filter((item) => item.pos)

          //
          const list = [...variants, ...otherVariants].sort(
            (a, b) => a.pos - b.pos
          )

          setDetectionRawDataVariationList(list)
        }
      }
    })

    const queryTumorVariants = useMutation({
      mutationFn: async (id: number) => {
        if (type === 'sample') {
          if (props.analysisInfo.pipelineVersion) {
            const query = {
              variants: {
                offset: 0,
                limit: 100,
                filter: changeV1Filter({
                  geneNameIn: TumorPanel,
                  CLINVAR_clnsig_final: ['PAT', 'LP'],
                  classification: ['pathogenic', 'likely pathogenic']
                })
              },
              parquetType: 'mt'
            }

            return await getGlsVariants(query)
          } else {
            const query = {
              pageNum: 1,
              pageSize: 100,
              filter: {
                geneNameIn: TumorPanel,
                CLINVAR_clnsig_final: ['PAT', 'LP'],
                classification: ['pathogenic', 'likely pathogenic']
              },
              sort: {}
            }

            return await getSamplesSvn(query, id)
          }
        } else {
          const query = {
            pageNum: 1,
            pageSize: 100,
            sort: {
              gene: 1,
              gene_min_clinsig: 1
            },
            filter: {
              geneNameIn: TumorPanel,
              CLINVAR_clnsig_final: ['PAT', 'LP'],
              classification: ['pathogenic', 'likely pathogenic']
            },
            analysisItemType: 'family_raw_data'
          }

          return await getAnalysisVariants(query, id)
        }
      },
      onSuccess: async (data: any) => {
        //post返回的结果

        const variant =
          data && data.data && data.data.list
            ? data.data.list
            : data.items
            ? data.items
            : []

        if (variant.length) {
          let variants = unique(
            variant.map((i: any) => {
              i.id = i._id

              i.keyID = `${i.chrom}_${i.pos}`

              return i
            }) ?? '',
            'keyID'
          )

          const geneNames = variants.map((i) => i.gene).filter((i) => i)

          //

          if (geneNames.length) {
            const OMIMs = await getOMIM.mutateAsync({
              geneNames
            })

            variants = variants.map((items) => {
              const temp = OMIMs.find(
                (item) =>
                  item.geneName === items.gene ||
                  (items.omim_info &&
                    items.omim_info.some((i: string) => i === item.geneName))
              )
              if (temp) {
                items.OMIM = temp
                items.OMIMData = unique(temp?.omimData ?? [], 'phenoName')
                  .filter((item) => item)
                  .map((items) => {
                    const inheritances: string[] = []

                    if (
                      items &&
                      items.clinicalSynopsis &&
                      items.clinicalSynopsis.INHERITANCE &&
                      Array.isArray(items.clinicalSynopsis.INHERITANCE)
                    ) {
                      items.clinicalSynopsis.INHERITANCE.forEach(
                        (str: string) => inheritances.push(str.toLowerCase())
                      )

                      const obj = _.cloneDeep(items.clinicalSynopsis)

                      delete obj.INHERITANCE

                      delete obj['MISCELLANEOUS']

                      delete obj['MOLECULAR BASIS']
                      const clinicalSynopsis = flatten3DArray(obj)

                      const sourceText = {} as any

                      clinicalSynopsis.map((item, index) => {
                        sourceText[index] = item
                      })

                      items.clinicalSynopsis_en = Object.getOwnPropertyNames(
                        sourceText
                      ).map((key) => sourceText[key])
                      const inheritance = formatVariantInheritance(
                        Array.from([...new Set(inheritances)]).join(',')
                      )

                      items.inheritance =
                        inheritance || inheritance !== ''
                          ? inheritance
                          : Array.from([
                              ...new Set(items.clinicalSynopsis.INHERITANCE)
                            ]).join(',')
                    }

                    items.phenoClinicalFeaturesCNStr =
                      items.phenoClinicalFeaturesCN?.map((item: any) => {
                        const temp = item
                          .filter((i: any) => i && i.text && i.text !== '.')
                          .map((i: any) => `${i.text}`)
                          .join('')

                        return temp
                      }) ?? []

                    items.phenoClinicalFeaturesENStr =
                      items.phenoClinicalFeatures?.map((item: any) => {
                        const temp = item
                          .filter((i: any) => i && i.text && i.text !== '.')
                          .map((i: any) => `${i.text}`)
                          .join('')

                        return temp
                      }) ?? []

                    items.phenoDescriptionCNStr =
                      items.phenoDescriptionCN?.map((item: any) => {
                        const temp = item
                          .filter((i: any) => i && i.text && i.text !== '.')
                          .map((i: any) => `${i.text}`)
                          .join('')

                        return temp
                      }) ?? []

                    items.phenoDescriptionENStr =
                      items.phenoDescription?.map((item: any) => {
                        const temp = item
                          .filter((i: any) => i && i.text && i.text !== '.')
                          .map((i: any) => `${i.text}`)
                          .join('')

                        return temp
                      }) ?? []

                    return items
                  })

                const geneDiseaseTranslated = unique(
                  items.OMIM?.geneDiseaseTranslated?.data ?? [],
                  'disease'
                )
                  .filter((item) => item)
                  .map((items) => {
                    return items
                  })

                const omimData = unique(
                  items.OMIM?.omimData ?? [],
                  'pheno_name_cn'
                )
                  .filter((item) => item)
                  .map((items) => {
                    return items
                  })
                  .map((item) => {
                    const inheritances: string[] = []

                    if (
                      item &&
                      item.clinicalSynopsis &&
                      item.clinicalSynopsis.INHERITANCE &&
                      Array.isArray(item.clinicalSynopsis.INHERITANCE)
                    ) {
                      item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                        inheritances.push(str.toLowerCase())
                      )
                      const inheritance = formatVariantInheritance(
                        Array.from([...new Set(inheritances)]).join(',')
                      )

                      item.inheritance =
                        inheritance || inheritance !== ''
                          ? inheritance
                          : Array.from([
                              ...new Set(item.clinicalSynopsis.INHERITANCE)
                            ]).join(',')
                    }

                    item.phenoDescriptionENStr =
                      item.phenoDescription?.map((item: any) => {
                        const temp = item
                          .filter((i: any) => i && i.text && i.text !== '.')
                          .map((i: any) => `${i.text}`)
                          .join('')

                        return temp
                      }) ?? []

                    return {
                      genetic_mode: item.inheritance,
                      disease: item.pheno_name_cn,
                      disease_description_cn: item.phenoDescriptionENStr,
                      phenotype: '',
                      omimId: item.phenoMim
                    }
                  })

                items.newOMIMData = items.OMIM?.geneDiseaseTranslated
                  ? geneDiseaseTranslated
                  : omimData
              }
              return items
            })
          }

          setDetectionTumorVariationList(
            [...variants].sort((a, b) => a.pos - b.pos)
          )
        }
      }
    })

    const reportsVariantsType = React.useMemo(() => {
      const obj = {
        KeyFinding: null as any,
        IncidentalDiscovery: null as any,
        CarrierScreening: null as any,
        ACMGDiscovery: null as any
      }

      Object.getOwnPropertyNames(obj).map((key) => {
        const temp = reportsVariants.find((item) => item.variantsType === key)
        if (temp) obj[key as 'KeyFinding'] = temp
      })

      return obj
    }, [reportsVariants])

    const ThalassemiaInfo = React.useMemo(() => {
      const obj = {
        HBA1: null as any,
        HBA2: null as any,
        HBB: null as any
      }

      Object.getOwnPropertyNames(obj).map((key) => {
        const temp = reportsVariants.find((item) => item.gene === key)
        if (temp) obj[key as 'HBA1'] = temp
      })

      return obj
    }, [reportsVariants])

    const affected_child_clinicalInformation = React.useMemo(() => {
      if (samples.length === 1) {
        return samples[0]?.sample?.clinicalInformation
      } else if (samples.length === 2) {
        return samples
          .map((row) => {
            let arr = []

            if (row && row.sample) {
              const terms = row.sample.terms

              if (terms && isJson(terms)) {
                arr = JSON.parse(terms)
              } else if (Array.isArray(terms)) arr = terms
            }

            return {
              ...row,
              terms: arr,
              terms_cn: arr.map((i: any) => i.title).join(';')
            }
          })
          .map((sample) => sample?.sample?.clinicalInformation)
          .join(';')
      } else {
        return samples
          .map((row) => {
            let arr = []

            if (row && row.sample) {
              const terms = row.sample.terms

              if (terms && isJson(terms)) {
                arr = JSON.parse(terms)
              } else if (Array.isArray(terms)) arr = terms
            }

            return {
              ...row,
              terms: arr,
              terms_cn: arr.map((i: any) => i.title).join(';')
            }
          })
          .find((item) => item.sample?.type === 'affected_child')?.sample
          .clinicalInformation
      }
    }, [samples])

    const affected_child_patientName = React.useMemo(() => {
      if (samples.length === 1) {
        return samples[0]?.patient?.patientName
      } else if (samples.length === 2) {
        return samples.map((sample) => sample?.patient?.patientName).join(';')
      } else {
        return samples.find((item) => item.sample?.type === 'affected_child')
          ?.patient.patientName
      }
    }, [samples])

    const flatten3DArray = (obj: { [x: string]: any }) => {
      const list = [] as any[]

      Object.getOwnPropertyNames(obj).map((key) => {
        const item = obj[key]

        //

        if (Array.isArray(item)) {
          item.map((i) => {
            list.push(i)
          })
        } else if (item && item.constructor === Object) {
          Object.getOwnPropertyNames(item).map((key) => {
            const items = item[key]

            items.map((i: any) => {
              list.push(i)
            })
          })
        }
      })

      return list
    }

    const initialValue = React.useMemo(() => {
      let initialValue: any[] = []

      if (report && report.templatePath === '1')
        initialValue = getTemplate1(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          t
        )
      else if (report && report.templatePath === '2')
        initialValue = getTemplate2(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          props,
          t
        )
      else if (report && report.templatePath === '3')
        initialValue = getTemplate3(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          samples,
          specialInheritance,
          t
        )
      else if (report && report.templatePath === '4')
        initialValue = getTemplate4(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          samples,
          userAcmgData,
          setsValue,
          setsValue2,
          t
        )
      else if (report && report.templatePath === '12')
        initialValue = getTemplate12(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          thalassemia,
          samples,
          userAcmgData,
          affected_child_clinicalInformation,
          t
        )
      else if (report && report.templatePath === '5')
        initialValue = getTemplate5(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          samples,
          t
        )
      else if (
        report &&
        (report.templatePath === '7' || report.templatePath === '6')
      )
        initialValue = template6And7(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          isRoh,
          samples,
          userAcmgData,
          affected_child_clinicalInformation,
          currentRohList,
          sanger,
          chromosomeData,
          detectionRawDataVariationList,
          detectionMTVariationList,
          strRang,
          i18n,
          isACMGSF,
          t
        )
      else if (report && report.templatePath === '8')
        initialValue = getTemplate8(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          samples,
          affected_child_clinicalInformation,
          props,
          sanger,
          switchGender,
          chromosomeData,
          t
        )
      else if (report && report.templatePath === '9')
        initialValue = getTemplate9(
          report,
          reportValue,
          reportsVariants,
          reportsVariantsType,
          samples,
          affected_child_clinicalInformation,
          props,
          sanger,
          chromosomeData,
          i18n,
          t
        )
      else if (report && report.templatePath === '10')
        initialValue = getTemplate10(
          report,
          samples,
          affected_child_clinicalInformation,
          t
        )
      else if (
        report &&
        (report.templatePath === '11' || report?.templatePath === '13')
      )
        initialValue = getTemplate11And13(
          report,
          reportsVariants,
          samples,
          userAcmgData,
          affected_child_clinicalInformation,
          chromosomeData,
          thalassemia,
          i18n,
          t
        )
      return initialValue
    }, [
      affected_child_clinicalInformation,
      chromosomeData,
      currentRohList,
      detectionMTVariationList,
      detectionRawDataVariationList,
      isACMGSF,
      isRoh,
      props,
      report,
      reportValue,
      reportsVariants,
      reportsVariantsType,
      samples,
      sanger,
      setsValue,
      setsValue2,
      switchGender,
      t,
      thalassemia,
      userAcmgData
    ])

    console.log(initialValue, 'initialValueinitialValueinitialValue')

    const handleGetText = () => {
      // 获取当前编辑器的值
      const text = [] as any

      // 遍历 initialValue 数组中的每个根节点

      initialValue.forEach((rootNode) => {
        const collectText = (node: any) => {
          if (node.text) {
            text.push(node.text)
          } else if (node.children) {
            node.children.forEach((child: any) => collectText(child))
          }
        }

        // 从当前根节点开始递归收集文本

        collectText(rootNode)
      })

      // 将文本片段连接成一个字符串

      const resultText = text.join('')

      return resultText
    }

    const handleGetDomText = (node: any) => {
      let text = ''

      // 处理文本节点
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent.trim()
      }

      // 处理元素节点
      else if (node.nodeType === Node.ELEMENT_NODE) {
        // 特殊处理输入类元素
        if (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA') {
          text += node.value.trim()
        }

        // 递归处理子节点
        node.childNodes.forEach((child: any) => {
          text += handleGetDomText(child)
        })
      }
      return text
    }

    const role = React.useMemo(() => {
      const user = JSON.parse(localStorage.getItem('user') || '{}')

      if (user.role_permission && user.role_permission.length) {
        const role = user.role_permission[0].role
        console.log(role)
        return role.name
      }
      return ''
    }, [])

    //

    React.useImperativeHandle(ref, () => {
      return {}
    })

    return (
      <Box maxHeight={'100%'} overflow={'auto'} minWidth={'600px'}>
        {report?.templatePath && Number(report?.templatePath) >= 21 ? (
          <Box>
            <Grid
              width={'100%'}
              container
              justifyContent={'space-between'}
              overflow="auto"
              direction={'column'}
              spacing={2}
            >
              <Grid item textAlign={'right'}>
                <Button
                  variant="contained"
                  onClick={() => {
                    const params = {
                      ...report,
                      reportJson: null,
                      updatedAt: new Date()
                    }
                    if (
                      report &&
                      report.metadata &&
                      (report.templatePath === '24' ||
                        report.templatePath === '25' ||
                        report.templatePath === '26')
                    ) {
                      if (isJson(report.metadata)) {
                        const value = JSON.parse(report.metadata)

                        value.signature = signature

                        value.signature2 = signature2

                        value.signature3 = signature3

                        value.signature4 = signature4

                        params.metadata = JSON.stringify(value)
                      }
                    }

                    updateReportsMutation.mutateAsync({
                      ...params,
                      changeData: []
                    })
                  }}
                  size="small"
                  startIcon={<File />}
                >
                  {t('save')}
                </Button>

                {/* {role === '审核人' &&
                report &&
                report.metadata &&
                (report.templatePath === '24' ||
                  report.templatePath === '25' ||
                  report.templatePath === '26') ? (
                  <div
                    {...getRootProps({
                      className: 'dropzone'
                    })}
                    style={{
                      display: 'inline-block',
                      marginLeft: 4
                    }}
                  >
                    <input {...getInputProps()} accept={'.png,.img'} />

                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<File />}
                    >
                      {t('添加公章')}
                    </Button>
                  </div>
                ) : (
                  ''
                )} */}

                <Button
                  sx={{
                    ml: 4
                  }}
                  variant="contained"
                  size="small"
                  startIcon={<FilePdfBox />}
                  onClick={async (e) => {
                    handleClickOpen()
                  }}
                >
                  {t('Add signature')}
                </Button>

                <Button
                  sx={{
                    ml: 4
                  }}
                  variant="contained"
                  size="small"
                  onClick={() => {
                    const text = `请对报告内容[${handleGetDomText(
                      wordDomReportRef.current
                    )}],针对患者需要描述全外检测的含义（200字左右），分析报告结果是阳性还是阴性，如果是阳性，针对检出位点文献需要结合数据库临床描述（提供参考文献）及患者临床进行详细对比描述。如果位点关联文献中包含治疗方案请列举并详细解读（提供文献或者数据库链接）。如果文献中没有相关治疗方案，请查询相关数据库，提供该基因关联疾病及各数据库中对该疾病的治疗方案，并提供相关链接。如果是阴性报告，请提供后续临床解决方案。`

                    setChatText(text)

                    //

                    if (ChatItem.current && ChatItem.current.open) {
                      ChatItem.current && ChatItem.current.handleClose()
                    } else {
                      ChatItem.current && ChatItem.current.handleClickOpen()

                      if (!chatText) {
                        ChatItem.current && ChatItem.current.setArticle(text)

                        ChatItem.current &&
                          ChatItem.current.handleNewUserMessage('', text)
                      }
                    }
                  }}
                >
                  {t('AI Assistant')}
                </Button>

                <Button
                  variant="contained"
                  onClick={() => {
                    wordReportRef.current &&
                      wordReportRef.current.exportWord &&
                      wordReportRef.current.exportWord(
                        `${report?.name}_${affected_child_patientName}`
                      )
                  }}
                  size="small"
                  startIcon={<File />}
                  sx={{
                    ml: 4
                  }}
                >
                  {t('Export to')}Word
                </Button>
              </Grid>

              <Grid item ref={wordDomReportRef}>
                <WordReport
                  ref={wordReportRef}
                  template={report?.templatePath ?? ''}
                  report={report}
                  reportValue={reportValue}
                  reportsVariants={reportsVariants}
                  reportsVariantsType={reportsVariantsType}
                  samples={samples}
                  affected_child_clinicalInformation={
                    affected_child_clinicalInformation
                  }
                  signature={signature}
                  signature2={signature2}
                  signature3={signature3}
                  signature4={signature4}
                  props={props}
                  sanger={sanger}
                  chromosomeData={chromosomeData}
                  userAcmgData={userAcmgData}
                  detectionMTVariationList={detectionMTVariationList}
                  strRang={strRang}
                  currentRohList={currentRohList}
                  isACMGSF={isACMGSF}
                  isRoh={isRoh}
                  detectionRawDataVariationList={detectionRawDataVariationList}
                  detectionTumorVariationList={detectionTumorVariationList}
                  affected_child_patientName={affected_child_patientName}
                />
              </Grid>

              <ChatClaudeItem ref={ChatItem} text={chatText} />
            </Grid>
          </Box>
        ) : (
          <Box maxHeight={'100%'}>
            <Grid
              width={'100%'}
              container
              justifyContent={'space-between'}
              overflow="auto"
            >
              <Grid item>
                <Button
                  variant="contained"
                  onClick={() => {
                    if (
                      slateRef.current &&
                      slateRef.current.editor &&
                      slateRef.current.editor.children
                    ) {
                      const params = {
                        ...report,
                        reportJson: JSON.stringify(
                          slateRef.current.editor.children
                        ),
                        updatedAt: new Date()
                      }

                      if (
                        report &&
                        report.metadata &&
                        (report.templatePath === '4' ||
                          report.templatePath === '12' ||
                          report.templatePath === '13')
                      ) {
                        if (isJson(report.metadata)) {
                          const value = JSON.parse(report.metadata)

                          value.value = slateRef.current.value

                          value.value2 = slateRef.current.value2

                          value.value3 = slateRef.current.value3

                          value.signature = slateRef.current.signature

                          value.signature2 = slateRef.current.signature2

                          value.signature3 = slateRef.current.signature3

                          params.metadata = JSON.stringify(value)

                          //
                        }
                      }

                      if (
                        report &&
                        report.metadata &&
                        (report.templatePath === '6' ||
                          report.templatePath === '7' ||
                          report.templatePath === '8' ||
                          report.templatePath === '9' ||
                          report.templatePath === '21' ||
                          report.templatePath === '22')
                      ) {
                        if (isJson(report.metadata)) {
                          const value = JSON.parse(report.metadata)

                          value.signature = slateRef.current.signature

                          value.signature2 = slateRef.current.signature2

                          value.signature3 = slateRef.current.signature3

                          params.metadata = JSON.stringify(value)
                        }
                      }

                      const changeData = slateRef.current
                        ?.getHistory()
                        ?.undos?.map((item: any) => {
                          return item.operations
                        })
                        .map((subArray: any) => {
                          const temp = {
                            remove_text: '',
                            insert_text: ''
                          }

                          subArray.forEach(
                            (item: { type: string; text: string }) => {
                              if (item.type === 'remove_text') {
                                temp.remove_text += item.text
                              } else if (item.type === 'insert_text') {
                                temp.insert_text += item.text
                              }
                            }
                          )

                          return temp
                        })

                      updateReportsMutation.mutateAsync({
                        ...params,
                        changeData: changeData
                      })
                    }
                  }}
                  size="small"
                  startIcon={<File />}
                >
                  {t('save')}
                </Button>
              </Grid>

              <Grid item>
                <Stack direction="row" spacing={2}>
                  {/* <Button
                onClick={handleClick}
                variant="contained"
                size="small"
                endIcon={<MenuDown />}
              >
                {t('Options')}
              </Button> */}

                  {/* <Button
                variant="contained"
                size="small"
                startIcon={<FilePdfBox />}
                onClick={async () => {
                  try {
                    messageRef?.current?.handleClick(
                      t('Exporting, please wait'),
                      'info'
                    )

                    //

                    console.time()

                    await handleExportWord()

                    console.timeEnd()

                    // PrintHtmlToPDF(containerRef.current, props.name?.name)
                  } catch (error) {
                    messageRef?.current?.handleClick(
                      t('Export failure'),
                      'error'
                    )
                  }
                }}
              >
                {t('Export to')}Word
              </Button> */}

                  {report?.templatePath === '13' ||
                  report?.templatePath === '11' ? (
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<FilePdfBox />}
                      onClick={async () => {
                        try {
                          messageRef?.current?.handleClick(
                            t('Exporting, please wait'),
                            'info'
                          )

                          //

                          console.time()

                          await handleExportThalassemia()

                          console.timeEnd()

                          // PrintHtmlToPDF(containerRef.current, props.name?.name)
                        } catch (error) {
                          messageRef?.current?.handleClick(
                            t('Export failure'),
                            'error'
                          )
                        }
                      }}
                    >
                      {t('Export to')}地贫
                    </Button>
                  ) : (
                    ''
                  )}

                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<FilePdfBox />}
                    onClick={async (e) => {
                      handleClickOpen()
                    }}
                  >
                    {t('Add signature')}
                  </Button>

                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<FilePdfBox />}
                    onClick={async () => {
                      try {
                        messageRef?.current?.handleClick(
                          t('Exporting, please wait'),
                          'info'
                        )

                        //

                        console.time()

                        await handlePrint()

                        console.timeEnd()

                        // PrintHtmlToPDF(containerRef.current, props.name?.name)
                      } catch (error) {
                        messageRef?.current?.handleClick(
                          t('Export failure'),
                          'error'
                        )
                      }
                    }}
                  >
                    {t('Export to')}PDF
                  </Button>

                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                      const text = `请对报告内容[${handleGetText()}],针对患者需要描述全外检测的含义（200字左右），分析报告结果是阳性还是阴性，如果是阳性，针对检出位点文献需要结合数据库临床描述（提供参考文献）及患者临床进行详细对比描述。如果位点关联文献中包含治疗方案请列举并详细解读（提供文献或者数据库链接）。如果文献中没有相关治疗方案，请查询相关数据库，提供该基因关联疾病及各数据库中对该疾病的治疗方案，并提供相关链接。如果是阴性报告，请提供后续临床解决方案。`

                      setChatText(text)

                      //

                      if (ChatItem.current && ChatItem.current.open) {
                        ChatItem.current && ChatItem.current.handleClose()
                      } else {
                        ChatItem.current && ChatItem.current.handleClickOpen()

                        if (!chatText) {
                          ChatItem.current && ChatItem.current.setArticle(text)

                          ChatItem.current &&
                            ChatItem.current.handleNewUserMessage('', text)
                        }
                      }
                    }}
                  >
                    {t('AI Assistant')}
                  </Button>

                  <ChatClaudeItem ref={ChatItem} text={chatText} />
                </Stack>
              </Grid>
            </Grid>

            <Divider />

            <Box
              display={'flex'}
              alignItems="center"
              flexDirection={'column'}
              justifyContent={'center'}
              paddingTop={10}
            >
              <Card
                sx={{
                  maxWidth: '85%',
                  minWidth: '50%',
                  fontFamily: 'sans-serif',
                  color: report?.templatePath === '9' ? 'black' : 'inherit'
                }}
                id="reportVartiant"
              >
                <CardContent ref={containerRef}>
                  <PasteHtmlExample
                    ref={slateRef}
                    value={
                      report?.reportJson
                        ? (report?.reportJson as any)
                        : initialValue
                    }
                    value1={radioValue}
                    value2={radioValue1}
                    value3={radioValue2}
                    signature={signature}
                    signature2={signature2}
                    signature3={signature3}
                    checked1={checkedValue}
                  />

                  <Grid container direction="row" padding={'0 20px'}>
                    {articles.length &&
                    (report?.templatePath === '1' ||
                      report?.templatePath === '2') ? (
                      articles.map((items, index) => {
                        return (
                          <Box key={index} paddingBottom={2}>
                            <Typography fontSize={16} color="primary.main">
                              {items.title}
                            </Typography>

                            <Typography fontSize={14} fontWeight={400}>
                              {items.excerpt}
                            </Typography>

                            <Typography
                              fontSize={14}
                              fontWeight={400}
                              component={'small'}
                              fontStyle={'italic'}
                              color="primary.main"
                            >
                              {`Year: ${items.year}; Cited by ${items.num_citations}; All ${items.num_versions} versions `}
                            </Typography>
                          </Box>
                        )
                      })
                    ) : (
                      <Typography textAlign={'center'}>
                        {/* {t('No Results')} */}
                      </Typography>
                    )}
                  </Grid>
                </CardContent>
              </Card>
            </Box>
          </Box>
        )}

        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={diaOpen}
          sx={{
            '& .MuiPaper-root': {
              maxWidth: 1200
            }
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {t('Electronic signature')}
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent dividers>
            <Box>
              <ElectronicSignature
                getImgUrl={(url) => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}')

                  if (role === '报告人' || report?.userId === user.id) {
                    //
                    setSignature(url)
                  }
                  if (role === '审核医师') {
                    //
                    setSignature3(url)
                  }
                  if (role === '审核人') {
                    //
                    setSignature2(url)
                  }

                  handleClose()
                }}
              />
            </Box>
          </DialogContent>
        </BootstrapDialog>

        <PositionedSnackbar ref={messageRef} />
      </Box>
    )
  }
)

export default CurrentReport
